
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Home from '@/components/Home'
import GroupList from '@/components/GroupList'
import GroupCreate from '@/components/GroupCreate'
import UserList from '@/components/UserList'
import UserCreate from '@/components/UserCreate'
import AssetStatusesList from '@/components/AssetStatusesList'
import AssetStatusesCreate from '@/components/AssetStatusesCreate'
import AssetTypesList from '@/components/AssetTypesList'
import AssetTypesCreate from '@/components/AssetTypesCreate'

import VehicleRegistrationList from '@/components/VehicleRegistrationList'
import VehicleRegistrationCreate from '@/components/VehicleRegistrationCreate'
import VehicleRegistrationView from '@/components/VehicleRegistrationView'
import VehicleRegistrationFormPreview from '@/components/VehicleRegistrationFormPreview'

import MaintenanceSchedule from '@/components/MaintenanceSchedule'

import ModulesList from '@/components/ModulesList'
import ModulesCreate from '@/components/ModulesCreate'

import ShopList from '@/components/ShopList'
import ShopCreate from '@/components/ShopCreate'

import RoleList from '@/components/RoleList'
import RoleCreate from '@/components/RoleCreate'
import PermissionList from '@/components/PermissionList'
import PermissionCreate from '@/components/PermissionCreate'
import GrantPermission from '@/components/GrantPermission'

import VendorList from '@/components/VendorList'
import VendorCreate from '@/components/VendorCreate'
import AssetGroupList from '@/components/AssetGroupList'
import AssetGroupCreate from '@/components/AssetGroupCreate'
import AssetGroupCopySetting from '@/components/AssetGroupCopySetting'

import AssetManufacturerCreate from '@/components/AssetManufacturerCreate'
import AssetManufacturerList from '@/components/AssetManufacturerList'
import AssetModelCreate from '@/components/AssetModelCreate'
import AssetModelList from '@/components/AssetModelList'
import AssetOwnershipCreate from '@/components/AssetOwnershipCreate'
import AssetOwnershipList from '@/components/AssetOwnershipList'
import AssetPoolCreate from '@/components/AssetPoolCreate'
import AssetPoolList from '@/components/AssetPoolList'

import ActivityLogList from '@/components/ActivityLogList'

import AssetDefectList from '@/components/AssetDefectList'
import AssetDefectCreate from '@/components/AssetDefectCreate'

import MeasurementUnitCreate from '@/components/MeasurementUnitCreate'
import MeasurementUnitList from '@/components/MeasurementUnitList'

import LocationList from '@/components/LocationList'
import LocationCreate from '@/components/LocationCreate'

import PageNotFound from '@/components/PageNotFound'

import AssetCreate from '@/components/AssetCreate'
import AssetList from '@/components/AssetList'
import AssetBasicFeatureCreate from '@/components/AssetBasicFeatureCreate'

import AssetContracts from '@/components/asset/AssetContracts'
import AssetAvailability from '@/components/asset/AssetAvailability'
import AssetLog from '@/components/asset/AssetLog'

import VendorEstimateCreate from '@/components/workorderestimate/VendorEstimateCreate'
import VendorEstimateList from '@/components/workorderestimate/VendorEstimateList'

import ComponentManufacturerCreate from '@/components/ComponentManufacturerCreate'
import ComponentManufacturerList from '@/components/ComponentManufacturerList'

import ComponentCategoryCreate from '@/components/ComponentCategoryCreate'
import ComponentCategoryList from '@/components/ComponentCategoryList'

import WarrantyCreate from '@/components/WarrantyCreate'
import WarrantyList from '@/components/WarrantyList'
import SrtList from '@/components/SrtList'
import SrtCreate from '@/components/SrtCreate'


import ComponentList from '@/components/ComponentList'
import ComponentCreate from '@/components/ComponentCreate'

import ComponentTransactionCreate from '@/components/ComponentTransactionCreate'
import ComponentTransactionList from '@/components/ComponentTransactionList'
import ComponentInventoryList from '@/components/ComponentInventoryList'
import ComponentInventoryRSBList from '@/components/ComponentInventoryRSBList'
import ComponentInventoryCreate from '@/components/ComponentInventoryCreate'
import EvComponentInventoryCreate from "../components/EvComponentInventoryCreate.vue";
import EvComponentInventoryView from "../components/EvComponentInventoryView.vue";

import WarehouseList from '@/components/warehouse/WarehouseList'
import WarehouseCreate from '@/components/warehouse/WarehouseCreate'
import WarehouseBinMapperList from '@/components/warehouse/WarehouseBinMapperList'
import WarehouseBinMapperCreate from '@/components/warehouse/WarehouseBinMapperCreate'

import CpiCodeCreate from '@/components/CpiCodeCreate'
import CpiCodeList from '@/components/CpiCodeList'

import ContractBillingMethodCreate from '@/components/ContractBillingMethodCreate'
import ContractBillingMethodList from '@/components/ContractBillingMethodList'

import ContractBillingFrequencyCreate from '@/components/ContractBillingFrequencyCreate'
import ContractBillingFrequencyList from '@/components/ContractBillingFrequencyList'

import CustomerClassList from '@/components/CustomerClassList'
import CustomerClassCreate from '@/components/CustomerClassCreate'

import ContractTypeCreate from '@/components/ContractTypeCreate'
import ContractTypeList from '@/components/ContractTypeList'

import CustomerList from '@/components/CustomerList'
import CustomerCreate from '@/components/CustomerCreate'
import CustomerView from '@/components/customer/CustomerView'
import DealerAccountView from '@/components/customer/DealerAccountView'


import TermList from '@/components/TermList'
import TermCreate from '@/components/TermCreate'

import CustomerContactList from '@/components/CustomerContactList'
import CustomerContactCreate from '@/components/CustomerContactCreate'

import CustomerAddressesReport from '@/components/CustomerAddressesReport'
import CustomerAddressesDetailsReport from '@/components/CustomerAddressesDetailsReport'

import ContractCreate from '@/components/ContractCreate'
import ContractList from '@/components/ContractList'
import ContractView from '@/components/ContractView'
import MetricTypeCreate from '@/components/MetricTypeCreate'
import MetricTypeList from '@/components/MetricTypeList'
import AssetMaintananceReportingStandardCreate from '@/components/AssetMaintananceReportingStandardCreate'
import AssetMaintananceReportingStandardList from '@/components/AssetMaintananceReportingStandardList'
import InsuranceCompanyCreate from '@/components/InsuranceCompanyCreate'
import InsuranceCompanyList from '@/components/InsuranceCompanyList'
import InsurancePolicyList from '@/components/insurance/InsurancePolicyList'

import RentalAgreementCreate from '@/components/RentalAgreementCreate'
import RentalAgreementList from '@/components/RentalAgreementList'
import RentalAgreementView from '@/components/rentalAgreement/RentalAgreementView'
import ContractAssetDetailCreate from '@/components/ContractAssetDetailCreate'
import ContractAssetDetailList from '@/components/ContractAssetDetailList'
import ContractTypeSectionMapperCreate from '@/components/ContractTypeSectionMapperCreate'
import ContractTypeSectionMapperList from '@/components/ContractTypeSectionMapperList'
import EffectiveCPIRateCreate from '@/components/EffectiveCPIRateCreate'
import EffectiveCPIRateList from '@/components/EffectiveCPIRateList'
import CPIProofReviewList from '@/components/CPIProofReviewList'
import Dashboard from '@/components/Dashboard'
// import ServiceDashboard from '@/components/ServiceDashboard'
import AssetDashboard from '@/components/AssetDashboard'
import RepairOrderDashboard from '@/components/RepairOrderDashboard'
import LeaseDashboard from '@/components/LeaseDashboard'
import RentalDashboard from '@/components/RentalDashboard'
import AccountDashboard from '@/components/AccountDashboard'
import VendorView from '@/components/VendorView'
import AssetView from '@/components/AssetView'
import CPIAcknowledgeMailSentList from '@/components/CPIAcknowledgeMailSentList'
import ContractAssetView from '@/components/contract/ContractAssetView'
import CPIProofReviewStatusChange from '@/components/CPIProofReviewStatusChange'
import EnquiryList from '@/components/Enquiries/EnquiryList'
import ViewEnquiry from '@/components/Enquiries/ViewEnquiry'
import ExtraChargeList from '@/components/charge/ExtraChargeList'
import ChargeList from '@/components/charge/ChargeList'
import ChargeCreate from '@/components/charge/ChargeCreate'
import ExtraChargeCreate from '@/components/charge/ExtraChargeCreate'
import CustomerNeeds from '@/components/CustomerNeeds'
import ReservationList from '@/components/Reservation/ReservationList'
import CustomerScopeRateList from '@/components/customer/CustomerScopeRateList'
import CustomerScopeRateCreate from '@/components/customer/CustomerScopeRateCreate'
import PaymentList from '@/components/payment/PaymentList'
import PaymentCreate from '@/components/payment/PaymentCreate'
import InvoiceList from '@/components/invoice/InvoiceList'
import InvoiceView from '@/components/invoice/InvoiceView'
import ReservationContent from '@/components/Reservation/ReservationContent'
import AvailableEquipment from '@/components/reports/AvailableEquipmentReport'
import ReservationReport from '@/components/reports/ReservationReport'
import WeeklyRentalReport from '@/components/reports/WeeklyRentalReport'
import EquipmentPoolTransfer from '@/components/reports/EquipmentPoolTransfer'
import OwnedEquipmentReport from '@/components/reports/OwnedEquipmentReport'
import UnitPermitDetailReport from '@/components/reports/UnitPermitDetail'
import HvutUnitDetailReport from '@/components/reports/HvutUnitDetail'
import FuelTicketDetailReport from '@/components/reports/FuelTicketDetailReport'
import DepreciationReviewReport from '@/components/reports/DepreciationReviewReport'
import InsurancePolicyReport from '@/components/reports/InsurancePolicyReport'
import CustomerRentalScopeRateReport from '@/components/reports/CustomerRentalScopeRateReport'
import CustomerReport from '@/components/reports/CustomerReport'
import InvoiceReport from '@/components/reports/InvoiceReport'
import InventoryReport from '@/components/reports/InventoryReport'
import GangsheetReport from '@/components/reports/GangsheetReport'
import PermitEntryReport from '@/components/reports/PermitEntryReport'
import RentalListingReport from '@/components/reports/RentalListingReport'
import LeaseContractReport from '@/components/reports/LeaseContractReport'
import EquipmentCurrentStatus from '@/components/reports/EquipmentCurrentStatus'
import DisposalInvoice from '@/components/reports/DisposalInvoiceReport'
import RentalReservationList from '@/components/customer/RentalReservationList'
import LeaseRevenueForecastReport from "@/components/LeaseRevenueForecastReport.vue";
import CorcentricInvoicesExtract from "@/components/invoice/CorcentricInvoicesExtract.vue";
//import Contr/add-etklogactDetails from '@/components/contract/ContractDetails'
import Profile from '@/components/Profile'
import ChangePassword from '@/components/ChangePassword'
import TransportRequestForm from '@/components/TransportRequestForm/TransportRequestForm'
import TransportRequestFormList from '@/components/TransportRequestForm/TransportRequestFormList'
import TravelRequestForm from '@/components/TravelRequestForm'
import ETKList from '@/components/ETK/ETKList'
import AddETKCodes from '@/components/ETK/AddETKCodes'
import TimeStore from '@/components/WorkEntry/TimeStore'
import UserLogEntryNew from '@/components/WorkEntry/UserLogEntryNew'
import UserLogEntryEdit from '@/components/WorkEntry/UserLogEntryEdit'
import UserLogEntryView from '@/components/WorkEntry/UserLogEntryView'
import EditTimeLog from '@/components/WorkEntry/EditTimeLog'
import PendingReservationList from '@/components/Reservation/PendingReservationList'
import PendingReservationContent from '@/components/Reservation/PendingReservationContent'
import CustomerLoginReport from '@/components/reports/CustomerLoginReport'
import CustomerRegisterReport from '@/components/reports/CustomerRegisterReport'
import RentalUtilizeEquipmentReport from '@/components/reports/RentalUtilizationEquipmentReport'

import CustomerInteractionReport from '@/components/reports/CustomerInteractionReport'
import BillingForecastReport from '@/components/reports/BillingForecastReport'
import TelematicsReadingList from '@/components/telematicsReading/TelematicsReadingList'
import TelematicsReadingCreate from '@/components/telematicsReading/TelematicsReadingCreate'
import BillingForecastDetailReport from '@/components/reports/BillingForecastDetailReport'
import SentEmail from '@/components/SentEmail'
import CreditApplicationList from '@/components/CreditApplicationList'

import CreditApplicationView from '@/components/CreditApplicationView'
import AssetWithoutReading from '@/components/AssetWithoutReading'
import VehiclePermitTypesCreate from '@/components/VehiclePermitTypesCreate'
import VehiclePermitTypesList from '@/components/VehiclePermitTypesList'
import VehiclePermitCreate from '@/components/VehiclePermitCreate'
import PermitList from '@/components/PermitList'
import AssetComponentCreate from '@/components/AssetComponentCreate'
import AssetComponentList from '@/components/asset/AssetComponentList'
import AssetFeatureCategoryCreate from '@/components/AssetFeatureCategoryCreate'
import AssetFeatureCategoryList from '@/components/AssetFeatureCategoryList'
import AssetFeatureCreate from '@/components/AssetFeatureCreate'
import AssetFeatureList from '@/components/AssetFeatureList'

import AssetStandardFeaturesList from '@/components/AssetStandardFeaturesList'
import AssetStandardFeaturesCreate from '@/components/AssetStandardFeaturesCreate'

import FeatureList from '@/components/FeatureList'
import FeatureCreate from '@/components/FeatureCreate'
import AssetStandardFeature from '@/components/asset/AssetStandardFeature'
import ComponentWarranty from '@/components/asset/ComponentWarranty'
import CustomerCreditInformation from '@/components/CustomerCreditInformation'

import CustomerCreditView from '@/components/CustomerCreditView'

import StandardDefectCreate from '@/components/StandardDefectCreate'
import StandardDefectList from '@/components/StandardDefectList'
import AssetWarrantyList from '@/components/AssetWarrantyList'
import AssetWarranty from '@/components/asset/AssetWarranty'
import ReasonCreate from '@/components/ReasonCreate'
import ReasonList from '@/components/ReasonList'
import WorkOrderCreate from '@/components/WorkOrderCreate'
import CustomerEstimateCreate from '@/components/CustomerEstimateCreate'
import WorkOrderList from '@/components/WorkOrderList'
import CustomerEstimateList from '@/components/CustomerEstimateList'
import EstimateMainList from '@/components/EstimateMainList'

import WorkOrderTemplateCreate from '@/components/WorkOrderTemplateCreate'
import WorkOrderTemplateList from '@/components/WorkOrderTemplateList'

import WorkOrderView from '@/components/WorkOrderView'
import VendorPurchaseOrderCreate from '@/components/VendorPurchaseOrderCreate'
import CustomerPurchaseOrderCreate from '@/components/CustomerPurchaseOrderCreate'
import AssetPurchaseOrderList from '@/components/asset/AssetPurchaseOrderList'
import PurchaseOrderAllList from '@/components/PurchaseOrderAllList'
import VendorPurchaseOrderItemList from '@/components/VendorPurchaseOrderItemList'
import CustomerPurchaseOrderItemList from '@/components/CustomerPurchaseOrderItemList'
import ImportData from '@/components/ImportData'
import ImportDataContent from '@/components/ImportDataContent'
import ImportDataReviewList from '@/components/ImportDataReviewList'
import MakeReservation from '@/components/MakeReservation'
import SearchAvailableAsset from '@/components/SearchAvailableAsset'
import PotentialCancellation from '@/components/reports/PotentialCancellation'
import RentalCancellation from '@/components/reports/RentalCancellation'
import ReadingNotificationList from '@/components/telematicsReading/ReadingNotificationList'
import CrmCreate from '@/components/CrmCreate'
import CrmList from '@/components/CrmList'
import CustomerNotices from '@/components/invoice/CustomerNotices'
import ACHNotification from '@/components/invoice/ACHNotification'
import UnitReadingsList from '@/components/UnitReadingsList'
import PastDueNotices from '@/components/invoice/PastDueNotices'
import EmailsReport from '@/components/EmailsReport'
import AssetInventoryListing from '@/components/asset/AssetInventoryListing'
import AssetInventoryUpdate from '@/components/asset/AssetInventoryUpdate'
import AssetWarrantyCreate from '@/components/asset/AssetWarrantyCreate'

import InsuranceAgencyList from '@/components/InsuranceAgencyList'
import InsuranceAgencyCreate from '@/components/InsuranceAgencyCreate'
import InsurancePolicyCreate from '@/components/insurance/InsurancePolicyCreate'
import InsurancePolicyView from '@/components/insurance/InsurancePolicyView'
import CustomerEstimateView from '@/components/CustomerEstimateView'
import VendorEstimateView from '@/components/workorderestimate/VendorEstimateView'
import CustomerPurchaseOrderView from '@/components/CustomerPurchaseOrderView'
import VendorPurchaseOrderView from '@/components/VendorPurchaseOrderView'
import ChecklistActionCreate from '@/components/ChecklistActionCreate'
import ChecklistActionList from '@/components/ChecklistActionList'
import ChecklistActionMapperCreate from '@/components/ChecklistActionMapperCreate'
import ChecklistActionMapperList from '@/components/ChecklistActionMapperList'
import BounceEmail from '@/components/BounceEmail'
import ServiceRecallCreate from '@/components/ServiceRecallCreate'
import RecallAssetMapper from '@/components/RecallAssetMapper'
import GLAccountList from '@/components/accounting/GLAccountList'
import GlChargeList from '@/components/accounting/GlChargeList'
import GLAccountCreate from '@/components/accounting/GLAccountCreate'
import GLChargeCreate from '@/components/accounting/GLChargeCreate'
import BillCreate from '@/components/accounting/BillCreate'
import BillList from '@/components/accounting/BillList'
import BillLineItemsList from '@/components/accounting/BillLineItemsList'
import BillView from '@/components/accounting/BillView'
import PurchaseOrderPreview from '@/components/PurchaseOrderPreview'
import InvoiceCreate from '@/components/invoice/InvoiceCreate'
import DisposalProceedsInvoiceCreate from '@/components/invoice/DisposalProceedsInvoiceCreate'
import WorkOrderInvoiceCreate from '@/components/invoice/WorkOrderInvoiceCreate'
import WorkOrderInvoiceView from '@/components/invoice/WorkOrderInvoiceView'
import ManualInvoiceView from '@/components/invoice/ManualInvoiceView'
import PartSaleInvoiceView from "@/components/invoice/PartSaleInvoiceView.vue";
import WarrantyLimitation from '@/components/WarrantyLimitation'
import OwlWarranty from '@/components/OwlWarranty'
import WorkOrderSalesInvoiceView from '@/components/invoice/WorkOrderSalesInvoiceView'
import InvoiceMainView from '@/components/invoice/InvoiceMainView'
import DefaultPriceBook from '@/components/customer/DefaultPriceBook'
import AssetrequisitionCreate from '@/components/asset/AssetrequisitionCreate'
import AssetRequisitionList from '@/components/asset/AssetRequisitionList'
import AssetExtraFeatureCreate from '@/components/AssetExtraFeatureCreate'
import ManualInvoiceTemplate from '@/components/invoice/ManualInvoiceTemplate'
import PartSaleInvoiceTemplate from "@/components/invoice/PartSaleInvoiceTemplate";
import RentalContractInvoiceView from '@/components/invoice/RentalContractInvoiceView'
import PermitCustomerMapper from '@/components/PermitCustomerMapper'
import PermitInvoice from '@/components/invoice/PermitInvoice'
import PermitInvoiceView from '@/components/invoice/PermitInvoiceView'
import CreditNoteCreate from '@/components/accounting/CreditNoteCreate'
import CreditNoteList from '@/components/accounting/CreditNoteList'
import CreditNoteView from '@/components/accounting/CreditNoteView'
import HVUTScheduleList from '@/components/hvut/HVUTScheduleList'
import HVUTCategoriesList from '@/components/hvut/HVUTCategoriesList'
import HVUTCategoriesUpdate from '@/components/hvut/UpdateHVUTCategories'
import UpdateNewHvutAsset from '@/components/hvut/UpdateNewHvutAsset'
import HvutInvoice from '@/components/invoice/HvutInvoice'
import HvutInvoiceView from '@/components/invoice/HvutInvoiceView'
import PermitInvoiceCreate from '@/components/invoice/PermitInvoiceCreate'
import HvutInvoiceCreate from '@/components/invoice/HvutInvoiceCreate'
import ConfirmedFhutUnitsList from '@/components/hvut/ConfirmedFhutUnitsList'
import Help from '@/components/Help'
import FAQ from '@/components/FAQ'
import FAQList from '@/components/FAQList'
import FAQHelp from '@/components/FAQHelp'
import IssuesReported from '@/components/IssuesReported'
import JournalList from '@/components/accounting/JournalList'
import JournalRecurringList from '@/components/accounting/JournalRecurringList'
import JournalCreate from '@/components/accounting/JournalCreate'
import RentalAgreementInvoice from '@/components/invoice/RentalAgreementInvoice'
import RentalInvoiceView from '@/components/invoice/RentalInvoiceView'
import debugbarList from '@/components/backend/Debugbar'
import GeneralLedgerReport from '@/components/accounting/reports/GeneralLedgerReport'
import CompanyInfo from '@/components/CompanyInfo'
import VendorPaymentList from '@/components/payment/VendorPaymentList'
import BillingForecastDetailList from '@/components/reports/BillingForecastDetailList'
import LeaseContractInvoice from '@/components/invoice/LeaseContractInvoice'
import LeaseContractInvoiceView from '@/components/invoice/LeaseContractInvoiceView'
import CheckList from '@/components/check/CheckList'
import CheckCreate from '@/components/check/CheckCreate'
import VendorPaymentView from '@/components/payment/VendorPaymentView'
import NewsCreate from '@/components/NewsCreate'
import NewsList from '@/components/NewsList'
import VendorPaymentPreview from '@/components/payment/VendorPaymentPreview'
import DebtNotesList from '@/components/payment/DebtNotesList'
import DebtNoteCreate from '@/components/payment/DebtNoteCreate'
import DebtNoteInteresetView from '@/components/payment/DebtNoteInteresetView'
import DebtPaymentReconciliation from '@/components/payment/DebtPaymentReconciliation'
import DebtPaymentReconciliationView from '@/components/payment/DebtPaymentReconciliationView'
import DebtPaymentReversalView from "@/components/payment/DebtPaymentReversalView.vue";
import BankTransferList from '@/components/accounting/BankTransferList'
import BankSummary from '@/components/BankSummary'
import VendorInvoicePreview from '@/components/accounting/VendorInvoicePreview'
import FuelIslandProductList from '@/components/FuelIslandProductList'
import FuelIslandProductCreate from '@/components/FuelIslandProductCreate'
import FuelDropList from '@/components/FuelDropList'
import FuelDropCreate from '@/components/FuelDropCreate'
import FuelDropView from '@/components/FuelDropView'
import FuelPricingCreate from '@/components/FuelPricingCreate'
import FuelPricingList from '@/components/FuelPricingList'
import ReceiptList from '@/components/ReceiptList'
import ReceiptCreate from '@/components/ReceiptCreate'
import FuelTicketList from '@/components/FuelTicketList'
import FuelTicketCreate from '@/components/FuelTicketCreate'
import FuelTicketView from '@/components/FuelTicketView'
import FuelTicketPreview from '@/components/FuelTicketPreview'
import FuelTicketInvoice from '@/components/invoice/FuelTicketInvoice'
import FuelTicketInvoiceView from '@/components/invoice/FuelTicketInvoiceView'
import FuelReadingList from '@/components/FuelReadingList'
import FuelReadingCreate from '@/components/FuelReadingCreate'
import FuelReadingView from '@/components/FuelReadingView'
import ReceiptInvoiceMapper from '@/components/ReceiptInvoiceMapper'
import ReceiptItemList from '@/components/ReceiptItemList'
import ReceiptItemView from '@/components/ReceiptItemView'
import ScheduleReportCreate from '@/components/ScheduleReportCreate'
import ScheduleReportList from '@/components/ScheduleReportList'
import AccountSetting from '@/components/accounting/AccountSetting'
import AvailableOverdueAsset from '@/components/reports/AvailableOverdueAsset'
import PostFinanceChargeInvoice from '@/components/invoice/PostFinanceChargeInvoice'
import FinanceChargeInvoiceView from '@/components/invoice/FinanceChargeInvoiceView'
import FinancialChargeInvoicePreview from '@/components/invoice/FinancialChargeInvoicePreview'
import TaxSummaryReport from '@/components/accounting/reports/TaxSummaryReport'
import ExpenseSummaryReport from '@/components/accounting/reports/ExpenseSummaryReport'
import IncomeSummaryReport from '@/components/accounting/reports/IncomeSummaryReport'
import ProfitAndLossReport from '@/components/accounting/reports/ProfitAndLossReport'
import AccountingDashboard from '@/components/accounting/AccountingDashboard'
import TrialBalanceReport from '@/components/accounting/reports/TrialBalanceReport'
import CustomerAROutstandingReport from '@/components/reports/CustomerAROutstandingReport'
import JournalView from '@/components/accounting/JournalView'
import DepriciationCreate from '@/components/asset/DepriciationCreate'
import DepreciationScheduleList from '@/components/asset/DepreciationScheduleList'
import AssetSaleCreate from '@/components/asset/AssetSaleCreate'
import AssetSaleList from '@/components/asset/AssetSaleList'
import CapitalCostAnalysisList from '@/components/asset/CapitalCostAnalysisList'
import PermitAdjust from '@/components/PermitAdjust'
import PostSaleBill from '@/components/asset/PostSaleBill'
import AssetSaleInvoiceView from '@/components/invoice/AssetSaleInvoiceView'
import DisposalInvoicePreview from '@/components/invoice/DisposalInvoicePreview'
import BatchList from '@/components/BatchList'
import WorkOrderPreview from '@/components/WorkOrderPreview'
// import PermitView from '@/components/PermitView'
import RecordReceipt from '@/components/RecordReceipt'
import VehiclePermitView from '@/components/VehiclePermitView'
import RecordReceiptList from '@/components/RecordReceiptList'
import RecordReceiptView from '@/components/RecordReceiptView'
import GangSheet from '@/components/ETK/GangSheet'
import InventoryTransfer from '@/components/InventoryTransfer'
import InventoryTransferList from '@/components/InventoryTransferList'
import CardRateHeaderCreate from '@/components/CardRateHeaderCreate'
import CardRateHeaderList from '@/components/CardRateHeaderList'
import CardRatesCustomerList from '@/components/CardRatesCustomerList'
import CardRateConfiguration from '@/components/CardRateConfiguration'
import CardRateConfigurationView from '@/components/CardRateConfigurationView'
import ScopeAgreementList from '@/components/ScopeAgreementList'
import ChargeCodeAccountList from '@/components/reports/ChargeCodeAccountList'
import LaborCostList from '@/components/LaborCostList'
import LaborCostCreate from '@/components/LaborCostCreate'
import WarrantyClaimCreate from '@/components/WarrantyClaimCreate'
import WarrantyClaimList from '@/components/WarrantyClaimList'
import ProgramCreate from '@/components/ProgramCreate'
import ProgramList from '@/components/ProgramList'
import ProgramAssetMapperList from '@/components/ProgramAssetMapperList'
import ProgramChildList from '@/components/ProgramChildList'
import ClaimCollection from '@/components/ClaimCollection'
import ClaimCollectionList from '@/components/ClaimCollectionList'
import WarrantyWorkOrder from '@/components/WarrantyWorkOrder'
import ApprovedWorkOrderList from '@/components/ApprovedWorkOrderList'
import ProgramActivityCreate from '@/components/ProgramActivityCreate'
import ShiftDetailList from '@/components/ETK/ShiftDetailList'
import CustomerStatement from '@/components/CustomerStatement'
import AssetFeatureReport from '@/components/AssetFeatureReport'
import LeaseContractExpiryReport from '@/components/LeaseContractExpiryReport'
import LeaseContractExpiryNonTemplate from '@/components/LeaseContractExpiryNonTemplate'
import LeaseRatesAndUtilization from '@/components/LeaseRatesAndUtilization'
import CitationList from '@/components/CitationList'
import CitationDetailList from '@/components/CitationDetailList'
import CitationEdit from '@/components/CitationEdit'
import CitationInvoiceView from '@/components/invoice/CitationInvoiceView'
import CitationInvoicePreview from '@/components/invoice/CitationInvoicePreview'
import RefundPaymentList from '@/components/accounting/refund/RefundPaymentList'
import RefundEligibleList from '@/components/accounting/refund/RefundEligibletList'
import VMRSCodeList from '@/components/VMRSCodeList'
import RentalActivityReport from '@/components/reports/RentalActivityReport'
import SubDayInPeriodReport from '@/components/reports/SubDayInPeriodReport'
import UnitsWithoutActiveContracts from '@/components/reports/UnitsWithoutActiveContracts'
import EquipmentMaster from '@/components/reports/EquipmentMaster'
import WarrantyView from '@/components/WarrantyView'
import CustomerAgedTrialBalanceSummary from '@/components/reports/CustomerAgedTrialBalanceSummary'
import PMUnitDetailReport from '@/components/reports/PMUnitDetailReport'
import PMUnitForecastReport from '@/components/reports/PMUnitForecastReport'
import MetricsBilledReport from '@/components/reports/MetricsBilledReport'
import CustomerAgedTrialBalanceDetail from '@/components/reports/CustomerAgedTrialBalanceDetail'
import NotePadReviewReport from '@/components/reports/NotePadReviewReport'
import BillingReadingForPeriod from '@/components/reports/BillingReadingForPeriod'
import NetBillingMetricsForPeriodReport from '@/components/reports/NetBillingMetricsReport'
import ManualBillingReport from '@/components/reports/ManualBillingReport'
import AgedTrialBalanceDetailGrid from '@/components/reports/AgedTrialBalanceDetailGrid'
import OutOfServiceHistory from '@/components/reports/OutOfServiceHistory'
import OutOfServiceDetails from '@/components/reports/OutOfServiceDetails'
import APTrialBalanceAsAtDetail from '@/components/reports/APTrialBalanceAsAtDetail'
import APVoucherDistributionEdit from '@/components/reports/APVoucherDistributionEdit'
import ARReceiptsAndApplications from '@/components/reports/ARReceiptsAndApplications'
import ActionAuditReport from '@/components/reports/ActionAuditReport'
import WorkOrderAccountingTransactions from '@/components/reports/WorkOrderAccountingTransactions'
import OpenOnAccountCash from '@/components/reports/OpenOnAccountCash'
import LTDUnitProfitAndLossSummary from '@/components/reports/LTDUnitProfitAndLossSummary'
import DepreciationNBVAsAt from '@/components/reports/DepreciationNBVAsAt'
import PMComplianceFacilityReport from '@/components/reports/PMComplianceFacilityReport'
import PMCompliancePoolReport from '@/components/reports/PMCompliancePoolReport'
import ContractCustomerReportList from '@/components/reports/ContractCustomerReportList'
import ContractEquipmentAsAt from '@/components/reports/ContractEquipmentAsAt'
import RentalActivityWithRatesReport from '@/components/reports/RentalActivityWithRatesReport'
import RepairHistoryReport from '@/components/reports/RepairHistoryReport'
import ContractRevenueReport from '@/components/reports/ContractRevenueReport'
import MileageUploadList from '@/components/MileageUploadList'
import MileageUploadDetailList from '@/components/MileageUploadDetailList'
import InvoiceDetailReport from '@/components/reports/InvoiceDetailReport'
import AnnualActualMetricVSContractMetric from '@/components/reports/AnnualActualMetricVSContractMetric'
import ActualMetricContractMetricReport from '@/components/reports/ActualMetricContractMetricReport'
import NonBillableUnitReport from '@/components/reports/NonBillableUnitReport'
import EquipmentAccountingRecordsReport from '@/components/reports/EquipmentAccountingRecordsReport'
import LaborManagementReport from '@/components/reports/LaborManagementReport'
import FeatureMapping from '@/components/FeatureMapping'
import EquipmentFeatureReport from '@/components/reports/EquipmentFeatureReport'
import RepresentativeList from '@/components/representative/RepresentativeList'
import RepresentativeCreate from '@/components/representative/RepresentativeCreate'
import OutOfServiceCreate from '@/components/OutOfServiceCreate'
import OutOfServiceList from '@/components/OutOfServiceList'
import DepreciationPreview from '@/components/asset/DepreciationPreview'
import CustomerDiscountCreate from '@/components/CustomerDiscountCreate'
import CustomerDiscountList from '@/components/CustomerDiscountList'
import DiscountCustomerList from '@/components/DiscountCustomerList'
import SubSystemList from '@/components/accounting/SubSystemList'
import AssetSaleView from '@/components/asset/AssetSaleView'
import ScopeRateView from '@/components/ScopeRateView'
import BankReceiptAdjustment from '@/components/accounting/BankReceiptAdjustment'
import JobPostingCreate from '@/components/JobPostingCreate'
import JobPostingList from '@/components/JobPostingList'
import JobsList from '@/components/JobsList'
import PhysicalCountCreate from '@/components/PhysicalCountCreate'
import PhysicalCountList from '@/components/PhysicalCountList'
import InventoryTicketList from '@/components/InventoryTicketList'
import SubletInProcessReport from '@/components/reports/SubletInProcessReport'
import FuelInventoryClearingSummaryReport from '@/components/reports/FuelInventoryClearingSummaryReport'
import CpiRateVerificationReport from '@/components/reports/CpiRateVerificationReport'
import AccruedLiabilityReport from '@/components/reports/AccruedLiabilityReport'
import FuelPriceLog from '@/components/FuelPriceLog'
import SystemParamsList from '@/components/SystemParamsList'
import SystemParamCreate from '@/components/SystemParamCreate'
import DebtNoteUnitDetailReport from '@/components/reports/DebtNoteUnitDetailReport'
import DebtNoteBalanceReport from '@/components/DebtNoteBalanceReport'
import DebtNoteRollForwardReport from '@/components/reports/DebtNoteRollForwardReport'
import DebtNotePostingDetailReport from '@/components/reports/DebtNotePostingDetailReport'
import NotesList from '@/components/NotesList'
import NotesCreate from '@/components/NotesCreate'
import WarrantyClaimReport from '@/components/WarrantyClaimReport'
import CustomerInvoiceLineDetailReport from '@/components/CustomerInvoiceLineDetailReport'
import WorkOrderInvoiceList from '@/components/WorkOrderInvoiceList'
import APPositivePayReport from '@/components/reports/APPositivePayReport'
import ShopPurchaseOrderReport from '@/components/reports/ShopPurchaseOrderReport'
import CostPerMetricByUnitReport from '@/components/CostPerMetricByUnitReport'
import LeaveHolidayCalendar from '@/components/LeaveHolidayCalendar'
import DebtNoteScheduleReport from '@/components/reports/DebtNoteScheduleReport'
import AssetTypeDeposit from '@/components/AssetTypeDeposit'
import AssetTypeDepositList from '@/components/AssetTypeDepositList'
import ClaimCollectionView from '@/components/ClaimCollectionView'
import CommentTypeConfig from '@/components/CommentTypeConfig'
import CommentTypeConfigList from '@/components/CommentTypeConfigList'
import VoucherPaymentMaintenanceList from '@/components/accounting/VoucherPaymentMaintenanceList'
import VoucherPaymentMaintenanceDetail from '@/components/accounting/VoucherPaymentMaintenanceDetail'
import LocationView from '@/components/LocationView'
import RentalInvoiceCreate from '@/components/RentalInvoiceCreate'
import LeaseInvoiceCreate from '@/components/LeaseInvoiceCreate'
import UserView from '@/components/UserView'
import LaborCostView from '@/components/LaborCostView'
import FuelPumpMapper from '@/components/FuelPumpMapper'
import FuelTankPumpMapperList from '@/components/FuelTankPumpMapperList'
import ContractEquipmentUtilization from '@/components/reports/ContractEquipmentUtilization'
import MaintenanceInclusionsAndExclusionsReport from '@/components/reports/MaintenanceInclusionsAndExclusionsReport'
import SuggestedOrder from '@/components/SuggestedOrder'
import DepreciationSetup from '@/components/DepreciationSetup'
import DepreciationSetupList from '@/components/DepreciationSetupList'
import ConformBillList from '@/components/accounting/ConformBillList'
import CustomerTotalFleetReport from '@/components/reports/CustomerTotalFleetReport'
import GLBalances from '@/components/GLBalances'
import InsuranceCertificateCreate from '@/components/InsuranceCertificateCreate'
import InsuranceCertificateList from '@/components/InsuranceCertificateList'
import GLTransactionList from '@/components/accounting/GLTransactionList'
import GLTrasactionUpdate from '@/components/accounting/GLTransactionUpdate'
import BillingReversingJournalEntry from '@/components/accounting/BillingReversingJournalEntry'
import BillingReversingJEDetails from '@/components/accounting/BillingReversingJEDetails'
import CustomerOrderPricingList from "../components/asset/CustomerOrderPricingList.vue";
import CustomerOrderPricingCreate from "../components/asset/CustomerOrderPricingCreate.vue";
import TaxList from '@/components/tax/TaxList'
import TaxCreate from '@/components/tax/TaxCreate'
import CustomerOrderForm from "../components/asset/CustomerOrderForm.vue";
import CustomerOrderList from "../components/asset/CustomerOrderList.vue";
import CustomerOrderFormPreview from "../components/asset/CustomerOrderFormPreview.vue";
import EvWarrantyClaimReview from "../components/warrantyClaimTabs/EvWarrantyClaimReview.vue";
import FHUTExceptionList from '@/components/invoice/FHUTExceptionList'

import GlAccountConfigurationCreate from "@/components/GlAccountConfigurationCreate.vue";
import GlAccountConfiguration from "@/components/GlAccountConfiguration.vue";
import ConsumerCreate from '@/components/ConsumerCreate';
import ConsumerList from '@/components/ConsumerList';
import RatesList from '@/components/rate/RatesList';
import RatesCreate from '@/components/rate/RatesCreate';
import PublicationCreate from '@/components/publication/PublicationCreate';
import PublicationList from '@/components/publication/PublicationList';

import CampaignList from '@/components/campaign/CampaignList';
import CampaignCreate from '@/components/campaign/CampaignCreate';
import CampaignRecallVinList from "@/components/campaign/CampaignRecallVinList";
import CampaignRecallVinCreate from "@/components/campaign/CampaignRecallVinCreate";
import VehicleInformation from '@/components/VehicleInformation.vue';
import UserFeedbackCreate from "@/components/UserFeedbackCreate.vue";
import UserFeedbackList from "@/components/UserFeedbackList.vue";
import UserFeedbackUpdate from "@/components/UserFeedbackUpdate.vue";
import GalleryCreate from "@/components/gallery/GalleryCreate.vue";
import GalleryList from "@/components/gallery/GalleryList.vue";
import TechnicalSupportRequest from '@/components/technicalSupport/TechnicalSupportRequest';
import TechnicalSupportQueue from '@/components/technicalSupport/TechnicalSupportQueue';
import VehicleOptionCreate from '@/components/vehicleOption/VehicleOptionCreate';
import VehicleOptionList from '@/components/vehicleOption/VehicleOptionList';
import AvailableVehiclesList from '@/components/AvailableVehiclesList';
import PartBackorderReporting from '@/components/PartBackorderReporting';
import RetailDeliveryReportCreate from '@/components/retailDeliveryReport/RetailDeliveryReportCreate';
import RetailDeliveryReportList from '@/components/retailDeliveryReport/RetailDeliveryReportList.vue'
import CreateCreditMemo from '@/components/CreateCreditMemo'
import CreditMemoLog from '@/components/CreditMemoLog'
import PositionCodeList from "@/components/PositionCodeList.vue";
import PositionCodeCreate from "@/components/PositionCodeCreate.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/refund-eligible-list',
      name: 'RefundEligibleList',
      component: RefundEligibleList
    },
    {
      path: '/refund-payment-list',
      name: 'RefundPaymentList',
      component: RefundPaymentList
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/resetpassword/:token',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/group/list',
      name: 'GroupList',
      component: GroupList
    },
    {
      path: '/group/create',
      name: 'GroupCreate',
      component: GroupCreate
    },
     {
      path: '/group/edit/:id',
      name: 'GroupEdit',
      component: GroupCreate
    },
    {
      path: '/gl-account-configuration/list',
      name: 'GlAccountConfiguration',
      component: GlAccountConfiguration
    },
    {
      path: '/gl-account-configuration/create',
      name: 'GlAccountConfigurationCreate',
      component: GlAccountConfigurationCreate
    },
    {
      path: '/gl-account-configuration/edit/:id',
      name: 'GlAccountConfigurationEdit',
      component: GlAccountConfigurationCreate
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/user/create',
      name: 'UserCreate',
      component: UserCreate
    },
    {
      path:'/user/view/:id',
      name:'UserView',
      component: UserView
    },
    {
      path: '/user/edit/:id',
      name: 'UserEdit',
      component: UserCreate
    },
    {
      path: '/assetstatuses/list',
      name: 'AssetStatusesList',
      component: AssetStatusesList
    },
    {
      path: '/assetstatuses/add',
      name: 'AssetStatusesCreate',
      component: AssetStatusesCreate
    },
    {
      path: '/assetstatuses/edit/:id',
      name: 'AssetStatusesEdit',
      component: AssetStatusesCreate
    },
    {
      path: '/assettypes/list',
      name: 'AssetTypesList',
      component: AssetTypesList
    },
    {
      path: '/assettypes/add',
      name: 'AssetTypesCreate',
      component: AssetTypesCreate
    },
    {
      path: '/assettypes/edit/:id',
      name: 'AssetTypesEdit',
      component: AssetTypesCreate
    },
    {
      path: '/warrantyregistration/list',
      name: 'VehicleRegistrationList',
      component: VehicleRegistrationList
    },
    {
      path: '/warrantyregistration/add',
      name: 'VehicleRegistrationCreate',
      component: VehicleRegistrationCreate
    },
    {
      path: '/warrantyregistration/edit/:id',
      name: 'VehicleRegistrationEdit',
      component: VehicleRegistrationCreate
    },
    {
      path: '/warrantyregistration/view/:id',
      name: 'VehicleRegistrationView',
      component: VehicleRegistrationView
    },
    {
      path: '/warrantyregistration/preview/:id',
      name: 'VehicleRegistrationFormPreview',
      component: VehicleRegistrationFormPreview
    },
    {
      path: '/modules/list',
      name: 'ModulesList',
      component: ModulesList
    },
    {
      path: '/modules/create',
      name: 'ModulesCreate',
      component: ModulesCreate
    },
    {
      path: '/modules/edit/:id',
      name: 'ModulesEdit',
      component: ModulesCreate
    },
    {
      path: '/roles/list',
      name: 'RoleList',
      component: RoleList
    },
    {
      path: '/roles/create',
      name: 'RoleCreate',
      component: RoleCreate
    },
    {
      path: '/roles/edit/:id',
      name: 'RoleEdit',
      component: RoleCreate
    },
    {
      path: '/shops/list',
      name: 'ShopList',
      component: ShopList
    },
    {
      path: '/shops/create',
      name: 'ShopCreate',
      component: ShopCreate
    },
    {
      path: '/shops/edit/:id',
      name: 'ShopEdit',
      component: ShopCreate
    },
    {
      path: '/permissions/list',
      name: 'PermissionList',
      component: PermissionList
    },
    {
      path: '/permissions/create',
      name: 'PermissionCreate',
      component: PermissionCreate
    },
    {
      path: '/permissions/edit/:id',
      name: 'PermissionEdit',
      component: PermissionCreate
    },
    {
      path: '/grantpermission',
      name: 'GrantPermission',
      component: GrantPermission
    },
    {
      path: '/vendor/list',
      name: 'VendorList',
      component: VendorList
    },
    {
      path: '/vendor/create',
      name: 'VendorCreate',
      component: VendorCreate
    },
    {
      path: '/vendor/edit/:id',
      name: 'VendorEdit',
      component: VendorCreate
    },
    {
      path: '/vendor/view/:id',
      name: 'VendorView',
      component: VendorView
    },
    {
      path: '/assetgroup/list',
      name: 'AssetGroupList',
      component: AssetGroupList
    },
    {
      path: '/assetgroup/add',
      name: 'AssetGroupCreate',
      component: AssetGroupCreate
    },
    {
      path: '/assetgroup/edit/:id',
      name: 'AssetGroupEdit',
      component: AssetGroupCreate
    },
    {
      path: '/assetgroup/copysetting/',
      name: 'AssetGroupCopySetting',
      component: AssetGroupCopySetting
    },
    {
      path: '/assetmanufacturer/add',
      name: 'AssetManufacturerCreate',
      component: AssetManufacturerCreate
    },
    {
      path: '/assetmanufacturer/edit/:id',
      name: 'AssetManufacturerEdit',
      component: AssetManufacturerCreate
    },
    {
      path: '/assetmanufacturer/list',
      name: 'AssetManufacturerList',
      component: AssetManufacturerList
    },
    {
      path: '/assetmodel/add',
      name: 'AssetModelCreate',
      component: AssetModelCreate
    },
    {
      path: '/assetmodel/edit/:id',
      name: 'AssetModelEdit',
      component: AssetModelCreate
    },
    {
      path: '/assetmodel/list',
      name: 'AssetModelList',
      component: AssetModelList
    },
    {
      path: '/measurementunit/create',
      name: 'MeasurementUnitCreate',
      component: MeasurementUnitCreate
    },
    {
      path: '/measurementunit/list',
      name: 'MeasurementUnitList',
      component: MeasurementUnitList
    },
    {
      path: '/measurementunit/edit/:id',
      name: 'MeasurementUnitEdit',
      component: MeasurementUnitCreate
    },
    {
      path: '/assetownership/add',
      name: 'AssetOwnershipCreate',
      component: AssetOwnershipCreate
    },
    {
      path: '/assetownership/edit/:id',
      name: 'AssetOwnershipEdit',
      component: AssetOwnershipCreate
    },
    {
      path: '/assetownership/list',
      name: 'AssetOwnershipList',
      component: AssetOwnershipList
    },
      {
      path: '/assetextrafeature/edit/:id',
      name: 'AssetExtraFeatureCreate',
      component: AssetExtraFeatureCreate
    },
    {
      path: '/assetpool/add',
      name: 'AssetPoolCreate',
      component: AssetPoolCreate
    },
    {
      path: '/assetpool/edit/:id',
      name: 'AssetPoolEdit',
      component: AssetPoolCreate
    },
    {
      path: '/assetpool/list',
      name: 'AssetPoolList',
      component: AssetPoolList
    },
    {
      path: '/location/list',
      name: 'LocationList',
      component: LocationList
    },
    {
      path: '/location/create',
      name: 'LocationCreate',
      component: LocationCreate
    },
    {
      path: '/location/edit/:id',
      name: 'LocationEdit',
      component: LocationCreate
    },
    {
      path: '/location/details/:id',
      name: 'LocationView',
      component: LocationView
    },
    {
      path: '/notFound',
      name: 'PageNotFound',
      component: PageNotFound
    },
    {
      path: '/asset/add',
      name: 'AssetCreate',
      component: AssetCreate
    },
    {
      path: '/asset/list',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/my-vehicles/list',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/available-vehicles-for-order/list',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/available-vehicles/list',
      name: 'AvailableVehiclesList',
      component: AvailableVehiclesList
    },
    {
      path: '/all-vehicles/list',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/asset-report/list',
      name: 'AssetList',
      component: AssetList
    },
    {
      path: '/asset/edit/:id',
      name: 'AssetEdit',
      component: AssetCreate
    },
    {
      path: '/asset/view/:id',
      name: 'AssetView',
      component: AssetView
    },
    {
      path: '/available-vehicle/view/:id',
      name: 'AvailableAssetView',
      component: AssetView
    },

    {
      path: '/asset-log/list',
      name: 'AssetLog',
      component: AssetLog
    },
    {
      path: '/assetcontract/list',
      name: 'AssetContracts',
      component: AssetContracts
    },
    {
      path: '/asset/check-availability',
      name: 'AssetAvailability',
      component: AssetAvailability
    },
    {
      path: '/part-manufacturer/add',
      name: 'ComponentManufacturerCreate',
      component: ComponentManufacturerCreate
    },
    {
      path: '/part-manufacturer/list',
      name: 'ComponentManufacturerList',
      component: ComponentManufacturerList
    },
    {
      path: '/part-manufacturer/edit/:id',
      name: 'ComponentManufacturerEdit',
      component: ComponentManufacturerCreate
    },
    {
      path: '/part-categories/list',
      name: 'ComponentCategoryList',
      component: ComponentCategoryList
    },
    {
      path: '/part-categories/add',
      name: 'ComponentCategoryCreate',
      component: ComponentCategoryCreate
    },
    {
      path: '/part-categories/edit/:id',
      name: 'ComponentCategoryEdit',
      component: ComponentCategoryCreate
    },
    // {
    //   path: '/warranty/list',
    //   name: 'WarrantyList',
    //   component: WarrantyList
    // },
    // {
    //   path: '/warranty/create',
    //   name: 'WarrantyCreate',
    //   component: WarrantyCreate
    // },
    {
      path: '/warranty/edit/:id',
      name: 'WarrantyEdit',
      component: WarrantyCreate
    },
    {
      path: '/part/list',
      name: 'ComponentList',
      component: ComponentList
    },
    {
      path: '/part/add',
      name: 'ComponentCreate',
      component: ComponentCreate
    },
    {
      path: '/part/edit/:id',
      name: 'ComponentEdit',
      component: ComponentCreate
    },
    {
      path: '/part-transaction/list/:id',
      name: 'ComponentTransactionList',
      component: ComponentTransactionList
    },
    {
      path: '/pdc-stock/list',
      name: 'ComponentInventoryList',
      component: ComponentInventoryList
    },
    {
      path: '/part-inventory-rsb/list/:id',
      name: 'ComponentInventoryRSBList',
      component: ComponentInventoryRSBList
    },
    {
      path: '/inventory-report/list',
      name: 'InventoryReport',
      component: InventoryReport
    },
    {
      path: '/part-transaction/add',
      name: 'ComponentTransactionCreate',
      component: ComponentTransactionCreate
    },
    {
      path: '/part-transaction/edit/:id',
      name: 'ComponentTransactionEdit',
      component: ComponentTransactionCreate
    },
    {
      path: '/part-inventory/edit/:id',
      name: 'ComponentInventoryEdit',
      component: ComponentInventoryCreate
    },
    {
      path: '/part-inventory/create',
      name: 'ComponentInventoryCreate',
      component: ComponentInventoryCreate
    },
    {
      path: '/warehouse/list',
      name: 'WarehouseList',
      component: WarehouseList
    },
    {
      path: '/warehouse/create',
      name: 'WarehouseCreate',
      component: WarehouseCreate
    },
    {
      path: '/warehouse/edit/:id',
      name: 'WarehouseEdit',
      component: WarehouseCreate
    },
    {
      path: '/warehouse-bin-mapper/list',
      name: 'WarehouseBinMapperList',
      component: WarehouseBinMapperList
    },
    {
      path: '/warehouse-bin-mapper/create',
      name: 'WarehouseBinMapperCreate',
      component: WarehouseBinMapperCreate
    },
    {
      path: '/warehouse-bin-mapper/edit/:id',
      name: 'WarehouseBinMapperEdit',
      component: WarehouseBinMapperCreate
    },

    {
      path: '/cpicode/list',
      name: 'CpiCodeList',
      component: CpiCodeList
    },
    {
      path: '/cpicode/create',
      name: 'CpiCodeCreate',
      component: CpiCodeCreate
    },
    {
      path: '/cpicode/edit/:id',
      name: 'CpiCodeEdit',
      component: CpiCodeCreate
    },
    {
      path: '/contractbillingmethod/list',
      name: 'ContractBillingMethodList',
      component: ContractBillingMethodList
    },
    {
      path: '/contractbillingmethod/create',
      name: 'ContractBillingMethodCreate',
      component: ContractBillingMethodCreate
    },
    {
      path: '/contractbillingmethod/edit/:id',
      name: 'ContractBillingMethodEdit',
      component: ContractBillingMethodCreate
    },
    {
      path: '/contractbillingfrequency/list',
      name: 'ContractBillingFrequencyList',
      component: ContractBillingFrequencyList
    },
    {
      path: '/contractbillingfrequency/create',
      name: 'ContractBillingFrequencyCreate',
      component: ContractBillingFrequencyCreate
    },
    {
      path: '/contractbillingfrequency/edit/:id',
      name: 'ContractBillingFrequencyEdit',
      component: ContractBillingFrequencyCreate
    },
    {
      path: '/customerclass/list',
      name: 'CustomerClassList',
      component: CustomerClassList
    },
    {
      path: '/customerclass/add',
      name: 'CustomerClassCreate',
      component: CustomerClassCreate
    },
    {
      path: '/customerclass/edit/:id',
      name: 'CustomerClassEdit',
      component: CustomerClassCreate
    },
    {
      path: '/contracttype/list',
      name: 'ContractTypeList',
      component: ContractTypeList
    },
    {
      path: '/contracttype/create',
      name: 'ContractTypeCreate',
      component: ContractTypeCreate
    },
    {
      path: '/contracttype/edit/:id',
      name: 'ContractTypeEdit',
      component: ContractTypeCreate
    },
    {
      path: '/dealer/list',
      name: 'CustomerList',
      component: CustomerList
    },
    {
      path: '/equipment-current-status-report/list',
      name: 'EquipmentCurrentStatus',
      component: EquipmentCurrentStatus
    },
    {
      path: '/metrics-billed-report/list',
      name: 'MetricsBilledReport',
      component: MetricsBilledReport
    },
    {
      path: '/customer-report/list',
      name: 'CustomerReport',
      component: CustomerReport
    },
    // {
    //   path: '/dealer/add',
    //   name: 'CustomerCreate',
    //   component: CustomerCreate
    // },
    {
      path: '/dealer/edit/:id',
      name: 'CustomerEdit',
      component: CustomerCreate
    },
    {
      path: '/dealer/view/:id',
      name: 'DealerAccountView',
      component: DealerAccountView
    },
    {
      path: '/term/list',
      name: 'TermList',
      component: TermList
    },
    {
      path: '/term/add',
      name: 'TermCreate',
      component: TermCreate
    },
    {
      path: '/term/edit/:id',
      name: 'TermEdit',
      component: TermCreate
    },

    {
      path: '/customercontact/list',
      name: 'CustomerContactList',
      component: CustomerContactList
    },

    {
      path: '/customer-contact-report/list',
      name: 'CustomerContactList',
      component: CustomerContactList
    },

    {
      path: '/customer-addresses-report/list',
      name: 'CustomerAddressesList',
      component: CustomerAddressesReport
    },

    {
      path: '/customer-addresses-details-report/list',
      name: 'CustomerAddressesDetailsReport',
      component: CustomerAddressesDetailsReport
    },

    {
      path: '/customercontact/add',
      name: 'CustomerContactCreate',
      component: CustomerContactCreate
    },
    {
      path: '/customercontact/edit/:id',
      name: 'CustomerContactEdit',
      component: CustomerContactCreate
    },
    {
      path: '/contract/list',
      name: 'ContractList',
      component: ContractList
    },
    {
      path: '/contract-report/list',
      name: 'ContractList',
      component: ContractList
    },
    {
      path: '/contract/create',
      name: 'ContractCreate',
      component: ContractCreate
    },
    {
      path: '/contract/edit/:id',
      name: 'ContractEdit',
      component: ContractCreate
    },
    {
      path: '/contract/view/:id',
      name: 'ContractView',
      component: ContractView
    },
    {
      path: '/activitylog/list',
      name: 'ActivityLogList',
      component: ActivityLogList
    },
    {
      path: '/price-book-history/list',
      name: 'ActivityLogList',
      component: ActivityLogList
    },
    {
      path: '/assetdefect/list',
      name: 'AssetDefectList',
      component: AssetDefectList
    },
    {
      path: '/assetdefect/create',
      name: 'AssetDefectCreate',
      component: AssetDefectCreate
    },
    {
      path: '/assetdefect/edit/:id',
      name: 'AssetDefectEdit',
      component: AssetDefectCreate
    },
    {
      path: '/assetdefect/view/:id',
      name: 'AssetDefectView',
      component: AssetDefectCreate
    },
    {
      path: '/metrictype/list',
      name: 'MetricTypeList',
      component: MetricTypeList
    },
    {
      path: '/metrictype/create',
      name: 'MetricTypeCreate',
      component: MetricTypeCreate
    },
    {
      path: '/metrictype/edit/:id',
      name: 'MetricTypeEdit',
      component: MetricTypeCreate
    },
    {
      path: '/assetmaintanance/list',
      name: 'AssetMaintananceReportingStandardList',
      component: AssetMaintananceReportingStandardList
    },
    {
      path: '/assetmaintanance/create',
      name: 'AssetMaintananceReportingStandardCreate',
      component: AssetMaintananceReportingStandardCreate
    },
    {
      path: '/assetmaintanance/edit/:id',
      name: 'AssetMaintananceReportingStandardEdit',
      component: AssetMaintananceReportingStandardCreate
    },
    {
      path: '/insurancecompany/list',
      name: 'InsuranceCompanyList',
      component: InsuranceCompanyList
    },
    {
      path: '/insurancecompany/add',
      name: 'InsuranceCompanyCreate',
      component: InsuranceCompanyCreate
    },
    {
      path: '/insurancecompany/edit/:id',
      name: 'InsuranceCompanyEdit',
      component: InsuranceCompanyCreate
    },
    {
        path: '/insurancepolicy/list',
        name: 'InsurancePolicyList',
        component: InsurancePolicyList
    },
    {
      path: '/insurance-policy-report/list',
      name: 'InsurancePolicyReport',
      component: InsurancePolicyReport
    },
    {
      path: '/rentalagreement/list',
      name: 'RentalAgreementList',
      component: RentalAgreementList
    },
    {
      path: '/rental-report/list',
      name: 'RentalListingReport',
      component: RentalListingReport
    },
    {
      path: '/rentalagreement/add',
      name: 'RentalAgreementCreate',
      component: RentalAgreementCreate
    },
    {
      path: '/rentalagreement/edit/:id',
      name: 'RentalAgreementEdit',
      component: RentalAgreementCreate
    },
    {
      path: '/rentalagreement/view/:id',
      name: 'RentalAgreementView',
      component: RentalAgreementView
    },
    {
      path: '/contractassetdetail/list',
      name: 'ContractAssetDetailList',
      component: ContractAssetDetailList
    },
    {
      path: '/contractassetdetail/add',
      name: 'ContractAssetDetailCreate',
      component: ContractAssetDetailCreate
    },
    {
      path: '/contractassetdetail/edit/:id',
      name: 'ContractAssetDetailEdit',
      component: ContractAssetDetailCreate
    },
    {
      path: '/contractassetdetail/view/:id',
      name: 'ContractAssetView',
      component: ContractAssetView
    },
    {
      path: '/contracttypesectionmapper/list',
      name: 'ContractTypeSectionMapperList',
      component: ContractTypeSectionMapperList
    },
    {
      path: '/contracttypesectionmapper/add',
      name: 'ContractTypeSectionMapperCreate',
      component: ContractTypeSectionMapperCreate
    },
    {
      path: '/contracttypesectionmapper/edit/:id',
      name: 'ContractTypeSectionMapperEdit',
      component: ContractTypeSectionMapperCreate
    },
    {
      path: '/effectivecpirate/list',
      name: 'EffectiveCPIRateList',
      component: EffectiveCPIRateList
    },
    {
      path: '/effectivecpirate/add',
      name: 'EffectiveCPIRateCreate',
      component: EffectiveCPIRateCreate
    },
    {
      path: '/effectivecpirate/edit/:id',
      name: 'EffectiveCPIRateEdit',
      component: EffectiveCPIRateCreate
    },
    {
      path: '/cpiproofreview/list',
      name: 'CPIProofReviewList',
      component: CPIProofReviewList
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    // {
    //   path: '/service-dashboard',
    //   name: 'ServiceDashboard',
    //   component: ServiceDashboard
    // },
    {
      path: '/asset-dashboard',
      name: 'AssetDashboard',
      component: AssetDashboard
    },
    {
      path: '/repair-order-dashboard',
      name: 'RepairOrderDashboard',
      component: RepairOrderDashboard
    },
    {
      path: '/lease-dashboard',
      name: 'LeaseDashboard',
      component: LeaseDashboard
    },
    {
      path: '/rental-dashboard',
      name: 'RentalDashboard',
      component: RentalDashboard
    },
    {
      path: '/account-dashboard',
      name: 'AccountDashboard',
      component: AccountDashboard
    },
    {
      path: '/cpiacknowledgementmailsent/list',
      name: 'CPIAcknowledgeMailSentList',
      component: CPIAcknowledgeMailSentList
    },
    {
      path: '/cpiproofreviewstatus',
      name: 'CPIProofReviewStatusChange',
      component: CPIProofReviewStatusChange
    },
    {
      path: '/inquiry/list',
      name: 'EnquiryList',
      component: EnquiryList
    },
    {
      path: '/viewinquiry/:id',
      name: 'ViewEnquiry',
      component: ViewEnquiry
    },
    {
      path: '/charge/create',
      name: 'ChargeCreate',
      component: ChargeCreate
    },
    {
      path: '/extra-charge/create',
      name: 'ExtraChargeCreate',
      component: ExtraChargeCreate
    },
    {
      path: '/extra-charge/edit/:id',
      name: 'ExtraChargeEdit',
      component: ExtraChargeCreate
    },
    {
      path: '/charge/edit/:id',
      name: 'ChargeEdit',
      component: ChargeCreate
    },
    {
      path: '/charge/list',
      name: 'listCharge',
      component: ChargeList
    },
    {
      path: '/tax/list',
      name: 'listTax',
      component: TaxList
    },
    {
      path: '/tax/create',
      name: 'createTax',
      component: TaxCreate
    },
    {
      path: '/tax/edit/:id',
      name: 'editTax',
      component: TaxCreate
    },
    {
      path: '/extra-charge/list',
      name: 'ExtraChargeList',
      component: ExtraChargeList
    },
    {
      path: '/customerneeds',
      name: 'CustomerNeeds',
      component: CustomerNeeds
    },
    {
      path: '/reservation/list',
      name: 'ReservationList',
      component: ReservationList
    },
    {
      path: '/scoperate/list',
      name: 'CustomerScopeRateList',
      component: CustomerScopeRateList
    },
    {
      path: '/customer-rental-scoperate-report/list',
      name: 'CustomerRentalScopeRateReport',
      component: CustomerRentalScopeRateReport
    },
    {
      path: '/scoperate/edit/:id',
      name: 'CustomerScopeRateEdit',
      component: CustomerScopeRateCreate
    },
    {
      path: '/scoperate/create',
      name: 'CustomerScopeRateCreate',
      component: CustomerScopeRateCreate
    },
    {
      path: '/payment/list',
      name: 'ListPayment',
      component: PaymentList
    },
    {
      path: '/debtnote/list',
      name: 'DebtNotesList',
      component: DebtNotesList
    },
    {
      path: '/debtnote/create',
      name: 'DebtNoteCreate',
      component: DebtNoteCreate
    },
    {
      path: '/debtnote/edit/:id',
      name: 'DebtNoteEdit',
      component: DebtNoteCreate
    },
    {
      path: '/debtnote/view/:id',
      name: 'DebtNoteInteresetView',
      component: DebtNoteInteresetView
    },
    {
      path: '/debtpayment/reconciliation',
      name: 'DebtPaymentReconciliation',
      component: DebtPaymentReconciliation
    },
    {
      path: '/debtpayment/reconciliation/view/:id',
      name: 'DebtPaymentReconciliationView',
      component: DebtPaymentReconciliationView
    },
    {
      path: '/debtpayment/reversal/view/:id',
      name: 'DebtPaymentReversalView',
      component: DebtPaymentReversalView
    },
    {
      path: '/vendor-payment/list',
      name: 'VendorPaymentList',
      component: VendorPaymentList
    },
    {
        path: '/payment/create',
        name: 'PaymentCreate',
        component: PaymentCreate
    },
    {
        path: '/invoice-report/list',
        name: 'InvoiceReport',
        component: InvoiceReport
      },
    {
      path: '/invoice/list',
      name: 'ListInvoice',
      component: InvoiceList
    },
    {
      path: '/corcentric-invoices-extract',
      name: 'CorcentricInvoicesExtract',
      component: CorcentricInvoicesExtract
    },
    // {
    //   path: '/invoice-disposal-report/list',
    //   name: 'ListInvoice',
    //   component: InvoiceList
    // },
    {
      path: '/invoice-disposal-report/list',
      name: 'DisposalInvoice',
      component: DisposalInvoice
    },
    {
      path: '/invoice/view/:id',
      name: 'ViewInvoice',
      component: RentalContractInvoiceView
    },
    {
      path: '/booking/view/:id',
      name: 'ReservationContent',
      component: ReservationContent
    },
    {
        path: '/pending-reservation/view/:id',
        name: 'PendingReservationContent',
        component: PendingReservationContent
    },
    {
      path: '/reservation/rental',
      name: 'RentalReservationList',
      component: RentalReservationList
    },
    {
      path: '/available-equipment-report/list',
      name: 'AvailableEquipment',
      component: AvailableEquipment
    },
    {
      path: '/reservation-report/list',
      name: 'ReservationReport',
      component: ReservationReport
    },
    {
      path: '/weekly-rental-report/list',
      name: 'WeeklyRentalReport',
      component: WeeklyRentalReport
    },
    {
      path: '/equipment-pool-report/list',
      name: 'EquipmentPoolTransfer',
      component: EquipmentPoolTransfer
    },
    {
      path: '/owned-equipment-report/list',
      name: 'OwnedEquipmentReport',
      component: OwnedEquipmentReport
    },
    {
      path: '/lease-contract-report/list',
      name: 'LeaseContract',
      component: LeaseContractReport
    },
    {
      path: '/maintenance-schedule',
      name: 'MaintenanceSchedule',
      component: MaintenanceSchedule
    },
    // {
    //   path: '/reservation/lease',
    //   name: 'ContractDetails',
    //   component: ContractDetails
    // },
    {
      path: '/reservation/lease',
      name: 'RentalReservationList',
      component: RentalReservationList
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/password/change',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/userpin/change',
      name: 'ChangeUserPin',
      component: ChangePassword
    },
    {
      path: '/transport-request/:flag',
      name: 'TransportRequestForm',
      component: TransportRequestForm
    },
    {
      path: '/transportrequest/list',
      name: 'TransportRequestFormList',
      component: TransportRequestFormList
    },
    {
      path: '/travelrequest',
      name: 'TravelRequestForm',
      component: TravelRequestForm
    },
    {
      path: '/etk/list',
      name: 'ETKList',
      component: ETKList
    },
    {
      path: '/etk/form',
      name: 'AddETKCodes',
      component: AddETKCodes
    },
    {
      path: '/etk/edit/:id',
      name: 'EtkListEdit',
      component: AddETKCodes
    },
    {
      path: '/work-entry/time',
      name: 'TimeStore',
      component: TimeStore
    },
    {
      path: '/work-entry/edit/:id',
      name: 'EditTimeLog',
      component: EditTimeLog
    },
    {
      path: '/user-log-entry',
      name: 'UserLogEntryNew',
      component: UserLogEntryNew
    },
    {
      path: '/user-log-entry/edit/:id',
      name: 'UserLogEntryEdit',
      component: UserLogEntryEdit
    },

    {
      path: '/pending-reservation/list',
      name: 'PendingReservationList',
      component: PendingReservationList
    },
    {
      path: '/report/customer-login',
      name: 'CustomerLoginReport',
      component: CustomerLoginReport
    },
    {
      path: '/telematics-reading/list',
      name: 'TelematicsReadingList',
      component: TelematicsReadingList
    },
    {
      path: '/telematics-reading/create',
      name: 'TelematicsReadingCreate',
      component: TelematicsReadingCreate
    },
    {
      path: '/report/customer-register',
      name: 'CustomerRegisterReport',
      component: CustomerRegisterReport
    },
    {
      path: '/report/utilize-asset',
      name: 'RentalUtilizeEquipmentReport',
      component: RentalUtilizeEquipmentReport
    },
    {
      path: '/report/customer-interaction',
      name: 'CustomerInteractionReport',
      component: CustomerInteractionReport
    },
    {
      path: '/billing-forecast/list',
      name: 'BillingForecastReport',
      component: BillingForecastReport
    },
    {
      path: '/report/billing-forecast-detail',
      name: 'BillingForecastDetailReport',
      component: BillingForecastDetailReport
    },
    {
      path: '/billing-forecast/detail/:id',
      name: 'BillingForecastDetail',
      component: BillingForecastDetailList
    },
    {
      path: '/billing-forecast/detail',
      name: 'BillingForecastList',
      component: BillingForecastDetailList
    },
    {
      path: '/sent/emails',
      name: 'SentEmail',
      component: SentEmail
    },
    {
      path: '/customer-credit-details/list',
      name: 'CreditApplicationList',
      component: CreditApplicationList
    },
    {
      path: '/dealer/credit-details/:id',
      name: 'CreditApplicationView',
      component: CreditApplicationView
    },
    {
      path: '/asset-without-reading/list',
      name: 'AssetWithoutReading',
      component: AssetWithoutReading
    },
    {
      path: '/vehiclepermittype/create',
      name: 'VehiclePermitTypesCreate',
      component: VehiclePermitTypesCreate
    },
    {
      path: '/vehiclepermittype/edit/:id',
      name: 'VehiclePermitTypesEdit',
      component: VehiclePermitTypesCreate
    },
    {
      path:'/vehiclepermittype/list',
      name:'VehiclePermitTypesList',
      component: VehiclePermitTypesList
    },
    {
      path: '/vehiclepermit/create',
      name: 'VehiclePermitCreate',
      component: VehiclePermitCreate
    },
    {
      path: '/vehiclepermit/edit/:id',
      name: 'VehiclePermitEdit',
      component: VehiclePermitCreate
    },
    {
      path:'/vehiclepermit/list',
      name:'PermitList',
      component: PermitList
    },
    {
      path:'/permit-entry-report/list',
      name:'PermitEntryReport',
      component: PermitEntryReport
    },
    {
      path:'/unit-permit-report/list',
      name:'UnitPermitDetailReport',
      component: UnitPermitDetailReport
    },
    {
      path:'/hvut-unit-report/list',
      name:'HvutUnitDetailReport',
      component: HvutUnitDetailReport
    },
    {
      path:'/confirmed-fhut-units/list',
      name:'ConfirmedFhutUnitsList',
      component: ConfirmedFhutUnitsList
    },
    {
      path:'/assetcomponent/create',
      name:'AssetComponentCreate',
      component: AssetComponentCreate
    },
    {
      path:'/assetcomponent/edit/:id',
      name:'AssetComponentEdit',
      component: AssetComponentCreate
    },
    {
      path:'/assetcomponent/list',
      name:'AssetComponentList',
      component: AssetComponentList
    },
    {
        path:'/assetstandardfeature/list',
        name:'AssetStandardFeaturesList',
        component: AssetStandardFeaturesList
    },
      {
          path: '/assetstandardfeature/add',
          name: 'AssetStandardFeaturesCreate',
          component: AssetStandardFeaturesCreate
      },
      {
          path: '/assetstandardfeature/edit/:id',
          name: 'AssetStandardFeaturesEdit',
          component: AssetStandardFeaturesCreate
      },
      {
      path:'/assetfeaturecategory/create',
      name:'AssetFeatureCategoryCreate',
      component: AssetFeatureCategoryCreate
    },
      {
          path: '/assetWarranty/edit/:id',
          name: 'AssetWarrantyEdit',
          component: AssetWarrantyCreate
      },
      {
          path:'/assetWarranty/create',
          name:'AssetWarrantyCreate',
          component: AssetWarrantyCreate
      },
    {
      path:'/assetfeaturecategory/edit/:id',
      name:'AssetFeatureCategoryEdit',
      component: AssetFeatureCategoryCreate
    },
    {
      path:'/assetfeaturecategory/list',
      name:'AssetFeatureCategoryList',
      component: AssetFeatureCategoryList
    },

      {
          path:'/feature/create',
          name:'FeatureCreate',
          component: FeatureCreate
      },

      {
          path:'/feature/list',
          name:'FeatureList',
          component: FeatureList
      },
      {
          path:'/feature/edit/:id',
          name:'FeatureEdit',
          component: FeatureCreate
      },
    {
      path:'/assetfeature/create',
      name:'AssetFeatureCreate',
      component: AssetFeatureCreate
    },
    {
      path:'/assetfeature/edit/:id',
      name:'AssetFeatureEdit',
      component: AssetFeatureCreate
    },
    {
      path:'/assetfeature/list',
      name:'AssetFeatureList',
      component: AssetFeatureList
    },
    {
        path:'/assetbasicfeature/edit/:id',
        name:'AssetBasicFeatureCreate',
        component: AssetBasicFeatureCreate
    },
    {
      path:'/asset-standard-feature/list',
      name:'AssetStandardFeature',
      component: AssetStandardFeature
    },
    {
      path:'/component-warranty/list',
      name:'ComponentWarranty',
      component: ComponentWarranty
    },
    {
        path:'/customer-credit-information/create',
        name:'CustomerCreditInformationCreate',
        component: CustomerCreditInformation
    },
    {
      path:'/customer-credit-information/create/:id',
      name:'CustomerCreditInformation',
      component: CustomerCreditInformation
    },
    {
      path:'/customer-credit-information/update/:id',
      name:'CustomerCreditInformationUpdate',
      component: CustomerCreditInformation
    },

    {
      path: '/customer-credit/view',
      name: 'CustomerCreditView',
      component: CustomerCreditView
    },
    {
      path:'/standard-defect/create',
      name:'StandardDefectCreate',
      component:StandardDefectCreate
    },
    {
      path:'/standard-defect/edit/:id',
      name:'StandardDefectEdit',
      component: StandardDefectCreate
    },
    {
      path:'/standard-defect/list',
      name:'StandardDefectList',
      component: StandardDefectList
    },
    {
      path:'/asset-warranty/list/:id',
      name:'AssetWarrantyList',
      component: AssetWarrantyList
    },
    {
      path:'/asset-warranties',
      name:'AssetWarranty',
      component: AssetWarranty
    },
    {
      path:'/damage-code/create',
      name:'ReasonCreate',
      component: ReasonCreate
    },
    {
      path:'/damage-code/edit/:id',
      name:'ReasonEdit',
      component: ReasonCreate
    },
    {
      path:'/damage-code/list',
      name:'ReasonList',
      component: ReasonList
    },
    {
      path:'/vendor-estimate/create',
      name:'VendorEstimateCreate',
      component: VendorEstimateCreate
    },
    {
      path:'/vendor-estimate/edit/:id',
      name:'VendorEstimateEdit',
      component: VendorEstimateCreate
    },
    {
      path:'/vendor-estimate/list',
      name:'VendorEstimateList',
      component: VendorEstimateList
    },
    {
      path:'/customer-estimate/create',
      name:'CustomerEstimateCreate',
      component: CustomerEstimateCreate
    },
    {
      path:'/customer-estimate/edit/:id',
      name:'CustomerEstimateEdit',
      component: CustomerEstimateCreate
    },
    {
      path:'/workorder/create',
      name:'WorkOrderCreate',
      component: WorkOrderCreate
    },
    {
      path:'/workorder/edit/:id',
      name:'WorkOrderEdit',
      component: WorkOrderCreate
    },

    {
      path:'/workordertemplate/create',
      name:'WorkOrderTemplateCreate',
      component: WorkOrderTemplateCreate
    },
    {
      path:'/workordertemplate/edit/:id',
      name:'WorkOrderTemplateEdit',
      component: WorkOrderTemplateCreate
    },
    {
      path:'/workordertemplate/list',
      name:'WorkOrderTemplateList',
      component: WorkOrderTemplateList
    },
    {
      path:'/workorder/list',
      name:'WorkOrderList',
      component: WorkOrderList
    },
    {
      path:'/estimate',
      name:'EstimateMainList',
      component: EstimateMainList
    },
    {
      path:'/customer-estimate/list',
      name:'CustomerEstimateList',
      component: CustomerEstimateList
    },
    {
      path: '/workorder/view/:id',
      name: 'WorkOrderView',
      component: WorkOrderView
    },
    {
      path:'/vendor-purchase-order/create',
      name:'VendorPurchaseOrderCreate',
      component: VendorPurchaseOrderCreate
    },
    {
      path:'/part-order/create',
      name:'CustomerPurchaseOrderCreate',
      component: CustomerPurchaseOrderCreate
    },
    {
      path:'/vendor-purchase-order/edit/:id',
      name:'VendorPurchaseOrderEdit',
      component: VendorPurchaseOrderCreate
    },
    {
      path:'/part-order/edit/:id',
      name:'CustomerPurchaseOrderEdit',
      component: CustomerPurchaseOrderCreate
    },
    {
      path:'/part-backorder-report',
      name:'PartBackorderReportingList',
      component: PartBackorderReporting
    },
    {
      path:'/asset-purchase-order/list',
      name:'AssetPurchaseOrderList',
      component: AssetPurchaseOrderList
    },
    {
      path:'/order-history/list',
      name:'PurchaseOrderAllList',
      component: PurchaseOrderAllList
    },
    {
      path:'/item-purchase-order/list',
      name:'PurchaseOrderAllList',
      component: PurchaseOrderAllList
    },
    {
      path:'/purchase-order-item/:id',
      name:'VendorPurchaseOrderItemList',
      component: VendorPurchaseOrderItemList
    },
    {
      path:'/customer-purchase-order-item/:id',
      name:'CustomerPurchaseOrderItemList',
      component: CustomerPurchaseOrderItemList
    },
    {
      path:'/import-data',
      name:'ImportData',
      component: ImportData
    },
    {
      path:'/import-data-content/:name',
      name:'ImportDataContent',
      component: ImportDataContent
    },
    {
      path:'/importdatareview/list',
      name:'ImportDataReviewList',
      component: ImportDataReviewList
    },
    {
      path:'/reservation/create',
      name:'MakeReservation',
      component: MakeReservation
    },
    {
      path:'/available-asset/search',
      name:'SearchAvailableAsset',
      component: SearchAvailableAsset
    },
    {
      path:'/report/potential-cancellation',
      name:'PotentialCancellation',
      component: PotentialCancellation
    },
    {
      path:'/report/rental-cancellation',
      name:'RentalCancellation',
      component: RentalCancellation
    },
    {
      path:'/reading-notification',
      name:'ReadingNotificationList',
      component: ReadingNotificationList
    },
    // {
    //   path:'/crm/create',
    //   name:'CrmCreate',
    //   component: CrmCreate
    // },
    // {
    //   path:'/crm/edit/:id',
    //   name:'CrmEdit',
    //   component: CrmCreate
    // },
    // {
    //   path:'/crm/list',
    //   name:'CrmList',
    //   component: CrmList
    // },
    {
      path:'/notice/courtesy',
      name:'CustomerNotices',
      component: CustomerNotices
    },
    {
      path:'/notice/ach',
      name:'ACHNotification',
      component: ACHNotification
    },
    {
      path:'/notice/past-due',
      name:'PastDueNotices',
      component: PastDueNotices
    },
    {
      path:'/reading/list',
      name:'UnitReadingsList',
      component: UnitReadingsList
    },
    {
      path: '/report/emails',
      name: 'EmailsReport',
      component: EmailsReport
    },
    {
      path:'/asset-inventory/list',
      name:'AssetInventoryListing',
      component: AssetInventoryListing
    },
    {
      path:'/asset-inventory/update/:id',
      name:'AssetInventoryUpdate',
      component: AssetInventoryUpdate
    },
    {
      path:'/insuranceagency/create',
      name:'InsuranceAgencyCreate',
      component: InsuranceAgencyCreate
    },
    {
      path:'/insuranceagency/edit/:id',
      name:'InsuranceAgencyEdit',
      component: InsuranceAgencyCreate
    },
    {
      path:'/insuranceagency/list',
      name:'InsuranceAgencyList',
      component: InsuranceAgencyList
    },
    {
      path:'/insurancepolicy/create',
      name:'InsurancePolicyCreate',
      component: InsurancePolicyCreate
    },
    {
      path:'/insurancepolicy/view/:id',
      name:'InsurancePolicyView',
      component: InsurancePolicyView
    },
    {
      path:'/insurancepolicy/edit/:id',
      name:'InsurancePolicyEdit',
      component: InsurancePolicyCreate
    },
    {
      path: '/customer-estimate/view/:id',
      name: 'CustomerEstimateView',
      component: CustomerEstimateView
    },
    {
      path:'/vendor-estimate/view/:id',
      name:'VendorEstimateView',
      component: VendorEstimateView
    },
    {
      path:'/part-order/view/:id',
      name:'CustomerPurchaseOrderView',
      component: CustomerPurchaseOrderView
    },
    {
      path:'/vendor-purchase-order/view/:id',
      name:'VendorPurchaseOrderView',
      component: VendorPurchaseOrderView
    },
    {
      path:'/checklist-action/create',
      name:'ChecklistActionCreate',
      component: ChecklistActionCreate
    },
    {
      path:'/checklist-action/edit/:id',
      name:'ChecklistActionEdit',
      component: ChecklistActionCreate
    },
    {
      path:'/checklist-action/list',
      name:'ChecklistActionList',
      component: ChecklistActionList
    },
    {
      path:'/checklist-action-mapper/create',
      name:'ChecklistActionMapperCreate',
      component: ChecklistActionMapperCreate
    },
    {
      path:'/checklist-action-mapper/edit/:id',
      name:'ChecklistActionMapperEdit',
      component: ChecklistActionMapperCreate
    },
    {
      path:'/checklist-action-mapper/list',
      name:'ChecklistActionMapperList',
      component: ChecklistActionMapperList
    },
    {
      path:'/service-recall/create',
      name:'ServiceRecallCreate',
      component: ServiceRecallCreate
    },
    {
      path:'/recall-asset-mapper',
      name:'RecallAssetMapper',
      component: RecallAssetMapper
    },
    {
      path:'/gl-account/create',
      name:'GLAccountCreate',
      component: GLAccountCreate
    },
    {
      path:'/gl-account/edit/:id',
      name:'GLAccountEdit',
      component: GLAccountCreate
    },
    {
      path:'/gl-charge/create',
      name:'GLChargeCreate',
      component: GLChargeCreate
    },
    {
      path:'/gl-charge/edit/:id',
      name:'GLChargeEdit',
      component: GLChargeCreate
    },
    {
      path:'/vendor-invoice/create',
      name:'BillCreate',
      component: BillCreate
    },
    {
      path:'/vendor-invoice/list',
      name:'BillList',
      component: BillList
    },
    {
      path:'/vendor-invoice-line-item/list',
      name:'BillLineItemsList',
      component: BillLineItemsList
    },
    {
      path:'/confirm-vendor-invoice/list',
      name:'ConformBillList',
      component: ConformBillList
    },
    {
      path:'/vendor-invoice/edit/:id',
      name:'BillEdit',
      component: BillCreate
    },
    {
      path:'/vendor-invoice/view/:id',
      name:'BillView',
      component: BillView
    },
    {
      path:'/gl-account/list',
      name:'GLAccountList',
      component: GLAccountList
    },
    {
      path:'/charge-account/list',
      name:'GlChargeList',
      component: GlChargeList
    },
    {
      path:'/preview',
      name:'PurchaseOrderPreview',
      component: PurchaseOrderPreview
    },
    {
      path: '/invoice/create',
      name: 'InvoiceCreate',
      component: InvoiceCreate
    },
    {
      path: '/invoice/dp/create',
      name: 'DisposalProceedsInvoiceCreate',
      component: DisposalProceedsInvoiceCreate
    },
    {
      path:'/invoice/edit/:id',
      name:'InvoiceEdit',
      component: InvoiceCreate
    },
    {
      path: '/invoice/wo/create',
      name: 'WorkOrderInvoiceCreate',
      component: WorkOrderInvoiceCreate
    },
    {
      path: '/invoice/wo/edit/:id',
      name: 'WorkOrderInvoiceEdit',
      component: WorkOrderInvoiceCreate
    },
    {
      path: '/invoice/wo/view/:id',
      name: 'WorkOrderSalesInvoiceView',
      component: WorkOrderSalesInvoiceView
    },
    {
      path: '/invoice/manual/view/:id',
      name: 'ManualInvoiceView',
      component: ManualInvoiceView
    },
    {
      path: '/invoice/part-sale/view/:id',
      name: 'PartSaleInvoiceView',
      component: PartSaleInvoiceView
    },

    {
      path:'/warranty-limitation/:id',
      name:'WarrantyLimitation',
      component: WarrantyLimitation
    },
    {
      path:'/warranty-owl/:id',
      name:'OwlWarranty',
      component: OwlWarranty
    },
    {
      path:'/invoice/wo/preview/:id',
      name:'WorkOrderInvoiceView',
      component: WorkOrderInvoiceView
    },
    {
      path:'/invoice/main/view/:id',
      name:'InvoiceMainView',
      component: InvoiceMainView
    },
    {
      path:'/price-book/create',
      name:'DefaultPriceBook',
      component: DefaultPriceBook
    },
    {
      path:'/asset-requisition/create',
      name:'AssetrequisitionCreate',
      component: AssetrequisitionCreate
    },
    {
      path:'/asset-requisition/update/:id',
      name:'AssetrequisitionEdit',
      component: AssetrequisitionCreate
    },
    {
      path:'/asset-requisition/list',
      name:'AssetRequisitionList',
      component: AssetRequisitionList
    },
    {
      path: '/invoice/manual/preview/:id',
      name: 'ManualInvoiceTemplate',
      component: ManualInvoiceTemplate
    },
    {
      path: '/invoice/part-sale/preview/:id',
      name: 'PartSaleInvoiceTemplate',
      component: PartSaleInvoiceTemplate
    },
    {
      path: '/invoice/permit/:id',
      name: 'PermitInvoice',
      component: PermitInvoice
    },
    {
      path: '/invoice/permit/preview/:id',
      name: 'PermitInvoiceView',
      component: PermitInvoiceView
    },
    {
      path: '/processed-permit',
      name: 'PermitCustomerMapper',
      component: PermitCustomerMapper
    },
    {
      path: '/invoice/preview/:id',
      name: 'InvoiceView',
      component: InvoiceView
    },
    {
      path:'/credit-note/create',
      name:'CreditNoteCreate',
      component: CreditNoteCreate
    },
    {
      path:'/credit-note/edit/:id',
      name:'CreditNoteEdit',
      component: CreditNoteCreate
    },
    {
      path:'/credit-note/list',
      name:'CreditNoteList',
      component: CreditNoteList
    },
    {
      path:'/credit-note/view/:id',
      name:'CreditNoteView',
      component: CreditNoteView
    },
    {
      path:'/fhut-schedule/list',
      name:'HVUTScheduleList',
      component: HVUTScheduleList
    },
    {
      path:'/fhut-categories/list',
      name:'HVUTCategoriesList',
      component: HVUTCategoriesList
    },
    {
      path:'/fhut-categories/update/:id',
      name:'HVUTCategoriesUpdate',
      component: HVUTCategoriesUpdate
    },
    {
      path:'/fhut-schedule/new',
      name:'UpdateNewHvutAsset',
      component: UpdateNewHvutAsset
    },
    {
      path: '/invoice/fhut/:id',
      name: 'HvutInvoice',
      component: HvutInvoice
    },
    {
      path: '/invoice/fhut/preview/:id',
      name: 'HvutInvoiceView',
      component: HvutInvoiceView
    },
    {
      path: '/invoice/permit/create',
      name: 'PermitInvoiceCreate',
      component: PermitInvoiceCreate
    },
    {
      path: '/invoice/permit/edit/:id',
      name: 'PermitInvoiceEdit',
      component: PermitInvoiceCreate
    },
    {
      path: '/invoice/fhut/create',
      name: 'HvutInvoiceCreate',
      component: HvutInvoiceCreate
    },
    {
      path: '/invoice/fhut/edit/:id',
      name: 'HvutInvoiceEdit',
      component: HvutInvoiceCreate
    },
    {
      path: '/fhut-exception/list',
      name: 'FHUTExceptionList',
      component: FHUTExceptionList,
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/faq/edit/:id',
      name: 'FAQEdit',
      component: FAQ
    },
    {
      path: '/faq/list',
      name: 'FAQList',
      component: FAQList
    },
    {
      path: '/faq/help',
      name: 'FAQHelp',
      component: FAQHelp
    },
    {
      path: '/issues-reported/list',
      name: 'IssuesReported',
      component: IssuesReported
    },
    {
      path:'/journal/list',
      name:'JournalList',
      component: JournalList
    },
    {
      path:'/journal-recurring/list',
      name:'JournalRecurringList',
      component: JournalRecurringList
    },
    {
      path:'/journal/create',
      name:'JournalCreate',
      component: JournalCreate
    },
    {
      path:'/journal/edit/:id',
      name:'JournalEdit',
      component: JournalCreate
    },

    {
      path:'/rental-agreement/invoice/:id',
      name:'RentalAgreementInvoice',
      component: RentalAgreementInvoice
    },
    {
      path:'/rental-invoice/view/:id',
      name:'RentalInvoiceView',
      component: RentalInvoiceView
    },
    {
      path:'/rental-invoice/create',
      name:'RentalInvoiceCreate',
      component: RentalInvoiceCreate
    },
    {
      path:'/lease-invoice/create',
      name:'LeaseInvoiceCreate',
      component: LeaseInvoiceCreate
    },
    {
      path:'/lease-contract/invoice/:id',
      name:'LeaseContractInvoice',
      component: LeaseContractInvoice
    },
    {
      path:'/lease-invoice/view/:id',
      name:'LeaseContractInvoiceView',
      component: LeaseContractInvoiceView
    },
    {
      path: '/report/general-ledger',
      name: 'GeneralLedgerReport',
      component: GeneralLedgerReport
    },
    {
      path: '/gl-detail-report/list',
      name: 'GeneralLedgerReport',
      component: GeneralLedgerReport
    },
    {
      path: '/company-info',
      name: 'CompanyInfo',
      component: CompanyInfo
    },
    {
      path:'/debugbar/list',
      name:'debugbarList',
      component: debugbarList
    },
    {
      path:'/check/list',
      name:'CheckList',
      component: CheckList
    },
    {
      path:'/check/create',
      name:'CheckCreate',
      component: CheckCreate
    },
    {
      path:'/check/edit/:id',
      name:'CheckEdit',
      component: CheckCreate
    },
    {
      path: '/vendor-payment/view/:id',
      name: 'VendorPaymentView',
      component: VendorPaymentView
    },
    {
      path:'/news/create',
      name:'NewsCreate',
      component: NewsCreate
    },
    {
      path:'/news/list',
      name:'NewsList',
      component: NewsList
    },
    {
      path:'/news/edit/:id',
      name:'NewsEdit',
      component: NewsCreate
    },
    {
      path: '/vendor-payment/preview',
      name: 'VendorPaymentPreview',
      component: VendorPaymentPreview
    },
    {
      path:'/bank-transfer/list',
      name:'BankTransferList',
      component: BankTransferList
    },
    {
      path:'/bank-summary/view',
      name:'BankSummary',
      component: BankSummary
    },

    {
      path: '/vendor-invoice/preview',
      name: 'VendorInvoicePreview',
      component: VendorInvoicePreview
    },
    {
        path: '/fuel-island-product/list',
        name: 'FuelIslandProductList',
        component: FuelIslandProductList
    },
    {
        path: '/fuel-island-product/create',
        name: 'FuelIslandProductCreate',
        component: FuelIslandProductCreate
    },
    {
        path: '/fuel-island-product/edit/:id',
        name: 'FuelIslandProductEdit',
        component: FuelIslandProductCreate
    },
    {
        path: '/fuel-drop/list',
        name: 'FuelDropList',
        component: FuelDropList
    },
    {
        path: '/fuel-drop/create',
        name: 'FuelDropCreate',
        component: FuelDropCreate
    },
    {
        path: '/fuel-drop/edit/:id',
        name: 'FuelDropEdit',
        component: FuelDropCreate
    },
    {
      path: '/fuel-drop/view/:id',
      name: 'FuelDropView',
      component: FuelDropView
  },
    {
      path:'/fuel-pricing/list',
      name:'FuelPricingList',
      component: FuelPricingList
    },
    {
      path:'/fuel-pricing/create',
      name:'FuelPricingCreate',
      component: FuelPricingCreate
    },
    {
      path:'/fuel-pricing/edit/:id',
      name:'FuelPricingEdit',
      component: FuelPricingCreate
    },
    {
      path:'/payment-receipt/list',
      name:'ReceiptList',
      component: ReceiptList
    },
    {
      path:'/payment-receipt/create',
      name:'ReceiptCreate',
      component: ReceiptCreate
    },
    {
      path:'/payment-receipt/edit/:id',
      name:'ReceiptEdit',
      component: ReceiptCreate
    },
    {
      path:'/fuel-ticket/list',
      name:'FuelTicketList',
      component: FuelTicketList
    },
    {
      path:'/fuel-ticket-report/list',
      name:'FuelTicketDetail',
      component: FuelTicketDetailReport
    },
    {
      path:'/fuel-ticket/create',
      name:'FuelTicketCreate',
      component: FuelTicketCreate
    },
    {
      path:'/fuel-ticket/edit/:id',
      name:'FuelTicketEdit',
      component: FuelTicketCreate
    },
    {
      path:'/fuel-ticket/view/:id',
      name:'FuelTicketView',
      component: FuelTicketView
    },
    {
      path: '/fuel-ticket/preview/:id',
      name: 'FuelTicketPreview',
      component: FuelTicketPreview
    },
    {
      path: '/invoice/fuel-ticket/:id',
      name: 'FuelTicketInvoice',
      component: FuelTicketInvoice
    },
    {
        path: '/invoice/fuel-ticket/preview/:id',
        name: 'FuelTicketInvoiceView',
        component: FuelTicketInvoiceView
    },
    {
        path:'/fuel-reading/list',
        name:'FuelReadingList',
        component: FuelReadingList
    },
    {
        path:'/fuel-reading/create',
        name:'FuelReadingCreate',
        component: FuelReadingCreate
    },
    {
      path:'/fuel-reading/view/:id',
      name:'FuelReadingView',
      component: FuelReadingView
  },
    {
        path:'/fuel-reading/edit/:id',
        name:'FuelReadingEdit',
        component: FuelReadingCreate
    },
    {
      path:'/receipt-invoice/map',
      name:'ReceiptInvoiceMapper',
      component: ReceiptInvoiceMapper
    },
    {
      path:'/receipt-invoice/map/:id',
      name:'ReceiptInvoiceMapperUpdate',
      component: ReceiptInvoiceMapper
    },
    {
      path:'/receipt-item/list',
      name:'ReceiptItemList',
      component: ReceiptItemList
    },
    {
      path: '/receipt-item/view/:id',
      name: 'ReceiptItemView',
      component: ReceiptItemView
    },
    {
      path: '/schedule-report/create',
      name: 'ScheduleReportCreate',
      component: ScheduleReportCreate
    },
    {
      path:'/schedule-report/list',
      name:'ScheduleReportList',
      component: ScheduleReportList
    },
    {
      path: '/schedule-report/edit/:id',
      name: 'ScheduleReportEdit',
      component: ScheduleReportCreate
    },
    {
      path:'/account-setting',
      name:'AccountSetting',
      component: AccountSetting
    },
    {
      path:'/available-overdue-asset/list',
      name:'AvailableOverdueAsset',
      component: AvailableOverdueAsset
  },
  {
    path:'/finance/invoice',
    name:'PostFinanceChargeInvoice',
    component: PostFinanceChargeInvoice
  },
  {
    path: '/finance-charge/view/:id',
    name: 'FinanceChargeInvoiceView',
    component: FinanceChargeInvoiceView
  },
  {
    path: '/finance-charge-invoice/view/:id',
    name: 'FinancialChargeInvoicePreview',
    component: FinancialChargeInvoicePreview
  },
  {
    path: '/report/tax-summary',
    name: 'TaxSummaryReport',
    component: TaxSummaryReport
    },
    {
      path: '/report/expense-summary',
      name: 'ExpenseSummaryReport',
      component: ExpenseSummaryReport
    },
    {
      path: '/report/income-summary',
      name: 'IncomeSummaryReport',
      component: IncomeSummaryReport
    },
    {
      path: '/report/profit-loss',
      name: 'ProfitAndLossReport',
      component: ProfitAndLossReport
    },
    {
      path: '/accounting/dashboard',
      name: 'AccountingDashboard',
      component: AccountingDashboard
    },
    {
      path: '/report/trial-balance',
      name: 'TrialBalanceReport',
      component: TrialBalanceReport
    },
    {
      path: '/report/customer-ar-outstanding',
      name: 'CustomerAROutstandingReport',
      component: CustomerAROutstandingReport
    },
    {
      path: '/journal/view/:id',
      name: 'JournalView',
      component: JournalView
    },

    {
      path:'/depreciation-review-report/list',
      name:'DepreciationReview',
      component: DepreciationReviewReport
    },
    {
      path:'/depreciation/create',
      name:'DepriciationCreate',
      component: DepriciationCreate
    },
    {
      path:'/depriciation/edit/:id',
      name:'DepriciationEdit',
      component: DepriciationCreate
    },
    {
      path:'/depreciation-schedule/list',
      name:'DepreciationScheduleList',
      component: DepreciationScheduleList
    },
    {
      path:'/asset-sale/create',
      name:'AssetSaleCreate',
      component: AssetSaleCreate
    },
    {
      path:'/asset-sale/edit/:id',
      name:'AssetSaleEdit',
      component: AssetSaleCreate
    },
    {
      path:'/asset-sale/list',
      name:'AssetSaleList',
      component: AssetSaleList
    },
    {
      path:'/capital-cost-analysis/list',
      name:'CapitalCostAnalysisList',
      component: CapitalCostAnalysisList
    },
    {
      path:'/asset-sale/view/:id',
      name:'AssetSaleView',
      component: AssetSaleView
    },
    {
      path:'/vehiclepermit/adjust/:id',
      name:'PermitAdjust',
      component: PermitAdjust
    },
    {
      path:'/bill-sale/create/:id',
      name:'PostSaleBill',
      component: PostSaleBill
    },
    {
      path: '/invoice/asset-sale/view/:id',
      name: 'AssetSaleInvoiceView',
      component: AssetSaleInvoiceView
    },
    {
      path: '/disposal-invoice/view/:id',
      name: 'DisposalInvoicePreview',
      component: DisposalInvoicePreview
    },
    {
      path:'/batch/list',
      name:'BatchList',
      component: BatchList
    },
    {
      path:'/workorder/preview',
      name:'WorkOrderPreview',
      component: WorkOrderPreview
    },
    {
      path:'/vehiclepermit/view/:id',
      name:'VehiclePermitView',
      component: VehiclePermitView
    },
    {
      path:'/record-receipt',
      name:'RecordReceipt',
      component: RecordReceipt
    },
    {
      path:'/record-receipt/edit/:id',
      name:'RecordReceiptEdit',
      component: RecordReceipt
    },
    {
      path:'/user-log-entry/view/:id',
      name:'UserLogEntryView',
      component: UserLogEntryView
    },
    {
      path: '/record-receipt/list',
      name: 'RecordReceiptList',
      component: RecordReceiptList
    },
    {
      path:'/record-receipt/view/:id',
      name:'RecordReceiptView',
      component: RecordReceiptView
    },
    {
      path: '/gang-sheet',
      name: 'GangSheet',
      component: GangSheet
    },
    {
      path: '/inventory-transfer',
      name: 'InventoryTransfer',
      component: InventoryTransfer
    },
    {
      path: '/inventory-transfer/list',
      name: 'InventoryTransferList',
      component: InventoryTransferList
    },
    {
      path: '/scope-header/create',
      name: 'CardRateHeaderCreate',
      component: CardRateHeaderCreate
    },
    {
      path: '/scope-header/edit/:id',
      name: 'CardRateHeaderEdit',
      component: CardRateHeaderCreate
    },
    {
      path: '/scope-header/list',
      name: 'CardRateHeaderList',
      component: CardRateHeaderList
    },
    {
      path: '/scope-customer/list/:id',
      name: 'CardRatesCustomerList',
      component: CardRatesCustomerList
    },
    {
      path: '/card-rate/create/:id',
      name: 'CardRateConfiguration',
      component: CardRateConfiguration
    },
    {
      path: '/card-rate/view/:id',
      name: 'CardRateConfigurationView',
      component: CardRateConfigurationView
    },
    {
      path: '/agreement/scope/:id',
      name: 'ScopeAgreementList',
      component: ScopeAgreementList
    },
    {
      path: '/charge-code-account/list',
      name: 'ChargeCodeAccountList',
      component: ChargeCodeAccountList
    },
    {
      path:'/labor-cost/create',
      name:'LaborCostCreate',
      component: LaborCostCreate
    },
    {
      path:'/labor-cost/edit/:id',
      name:'LaborCostEdit',
      component: LaborCostCreate
    },
    {
      path: '/labor-cost/list',
      name: 'LaborCostList',
      component: LaborCostList
    },
    {
      path:'/labor-cost/view/:id',
      name:'LaborCostView',
      component: LaborCostView
    },
    {
      path: '/warranty-claim/create',
      name: 'WarrantyClaimCreate',
      component: WarrantyClaimCreate
    },
    {
      path: '/warranty-claim/edit/:id',
      name: 'WarrantyClaimEdit',
      component: WarrantyClaimCreate
    },
    {
      path: '/warranty-claim/queue',
      name: 'WarrantyClaimList',
      component: WarrantyClaimList
    },
    {
      path: '/program/create',
      name: 'ProgramCreate',
      component: ProgramCreate
    },
    {
      path: '/program/edit/:id',
      name: 'ProgramEdit',
      component: ProgramCreate
    },
    {
      path: '/program/list',
      name: 'ProgramList',
      component: ProgramList
    },
    {
      path: '/program-asset/list/:id',
      name: 'ProgramAssetMapperList',
      component: ProgramAssetMapperList
    },
    {
      path: '/program-child/list/:id',
      name: 'ProgramChildList',
      component: ProgramChildList
    },
    {
      path: '/claim-collection/:id',
      name: 'ClaimCollection',
      component: ClaimCollection
    },
    {
      path: '/claim-collection/edit/:id',
      name: 'ClaimCollectionEdit',
      component: ClaimCollection
    },
    {
      path: '/claim-collection/view/:id',
      name: 'ClaimCollectionView',
      component: ClaimCollectionView
    },
    // {
    //   path: '/list/claim-collection',
    //   name: 'ClaimCollectionList',
    //   component: ClaimCollectionList
    // },
    {
      path: '/warranty-work-order/create/:id',
      name: 'WarrantyWorkOrder',
      component: WarrantyWorkOrder
    },
    {
      path: '/warranty-work-order/edit/:id',
      name: 'WarrantyWorkOrderEdit',
      component: WarrantyWorkOrder
    },
    {
      path: '/warranty-work-order/view/:id',
      name: 'WarrantyWorkOrderView',
      component: WarrantyWorkOrder
    },

    {
      path:'/approved-workorder/list',
      name:'ApprovedWorkOrderList',
      component: ApprovedWorkOrderList
    },
    {
      path:'/fhut-schedule/:flag',
      name:'UpdateHvutAssetSchedule',
      component: UpdateNewHvutAsset
    },
    {
      path: '/program-activity/create/:id',
      name: 'ProgramActivityCreate',
      component: ProgramActivityCreate
    },
    {
      path: '/shift-detail/list',
      name: 'ShiftDetailList',
      component: ShiftDetailList
    },
    {
      path: '/gangsheet-report/list',
      name: 'GangsheetReport',
      component: GangsheetReport
    },

    {
      path: '/customer-statement',
      name: 'CustomerStatement',
      component: CustomerStatement
    },
    {
      path: '/asset-feature/list',
      name: 'AssetFeatureReport',
      component: AssetFeatureReport
    },
    {
      path: '/lease-contract-expiry/list',
      name: 'LeaseContractExpiryReport',
      component: LeaseContractExpiryReport
    },
    {
      path: '/lease-contract-expiry-non-template/list',
      name: 'LeaseContractExpiryNonTemplate',
      component: LeaseContractExpiryNonTemplate
    },
    {
      path: '/lease-rates-and-utilization/list',
      name: 'LeaseRatesAndUtilization',
      component: LeaseRatesAndUtilization
    },
    {
      path: '/lease-revenue-forecast/list',
      name: 'LeaseRevenueForecastReport',
      component: LeaseRevenueForecastReport
    },
    {
      path: '/citation/list',
      name: 'CitationList',
      component: CitationList
    },
    {
      path: '/citation-detail/list/:batch',
      name: 'CitationDetailList',
      component: CitationDetailList
    },
    {
      path: '/citation/edit/:id',
      name: 'CitationEdit',
      component: CitationEdit
    },
    {
      path: '/citation-invoice/view/:id',
      name: 'CitationInvoiceView',
      component: CitationInvoiceView
    },
    {
      path: '/citation-invoice/preview/:id',
      name: 'CitationInvoicePreview',
      component: CitationInvoicePreview
    },
    {
      path: '/vmrs-code/list',
      name: 'VMRSCodeList',
      component: VMRSCodeList
    },
    {
      path: '/rental-activity-report/list',
      name: 'RentalActivityReport',
      component: RentalActivityReport
    },
    {
      path: '/rental-activity-rates-report/list',
      name: 'RentalActivityWithRatesReport',
      component: RentalActivityWithRatesReport
    },
    {
      path: '/substitute-unit-report/list',
      name: 'SubDayInPeriodReport',
      component: SubDayInPeriodReport
    },
    {
      path: '/units-without-active-contracts/list',
      name: 'UnitsWithoutActiveContracts',
      component: UnitsWithoutActiveContracts
    },
    {
      path: '/equipment-master/list',
      name: 'EquipmentMaster',
      component: EquipmentMaster
    },
    {
        path: '/warranty/view/:id',
        name: 'WarrantyView',
        component: WarrantyView
    },
    {
      path: '/report/customer-aged-trial-balance-summary',
      name: 'CustomerAgedTrialBalanceSummary',
      component: CustomerAgedTrialBalanceSummary
    },
    {
      path: '/pm-unit-detail-report/list',
      name: 'PMUnitDetailReport',
      component: PMUnitDetailReport
    },
    {
      path: '/pm-unit-forecast-report/list',
      name: 'PMUnitForecastReport',
      component: PMUnitForecastReport
    },
    {
      path: '/report/aged-trial-balance-detail',
      name: 'CustomerAgedTrialBalanceDetail',
      component: CustomerAgedTrialBalanceDetail
    },
    {
      path: '/report/note-pad-review',
      name: 'NotePadReviewReport',
      component: NotePadReviewReport
    },
    {
      path: '/billing-reading-for-period-report/list',
      name: 'BillingReadingForPeriod',
      component: BillingReadingForPeriod
    },
    {
      path: '/net-billing-metrics-report/list',
      name: 'NetBillingMetricsForPeriodReport',
      component: NetBillingMetricsForPeriodReport
    },
    {
      path: '/manual-billing/list',
      name: 'ManualBillingReport',
      component: ManualBillingReport
    },
    {
      path: '/report/aged-trial-balance-detail-grid',
      name:'AgedTrialBalanceDetailGrid',
      component: AgedTrialBalanceDetailGrid
    },
    {
      path: '/out-of-service-history/list',
      name: 'OutOfServiceHistory',
      component: OutOfServiceHistory
    },
    {
      path: '/out-of-service-details/list',
      name: 'OutOfServiceDetails',
      component: OutOfServiceDetails
    },
    {
      path:'/report/ap-trial-balance-as-at-detail',
      name:'APTrialBalanceAsAtDetail',
      component: APTrialBalanceAsAtDetail
    },
    {
      path:'/report/ap-voucher-distribution-edit',
      name:'APVoucherDistributionEdit',
      component: APVoucherDistributionEdit
    },
    {
      path:'/report/ap-positive-pay-listing',
      name:'APPositivePayListing',
      component: APPositivePayReport
    },
    {
      path:'/report/shop-purchase-orders',
      name:'ShopPurchaseOrderReport',
      component: ShopPurchaseOrderReport
    },
    {
      path:'/report/ar-receipt-and-application',
      name:'ARReceiptsAndApplications',
      component: ARReceiptsAndApplications
    },
    {
      path:'/report/work-order-accounting-transaction',
      name:'WorkOrderAccountingTransactions',
      component: WorkOrderAccountingTransactions
    },
    {
      path:'/report/open-on-account-cash',
      name:'OpenOnAccountCash',
      component: OpenOnAccountCash
    },
    {
      path:'/report/ltd-unit-profit-loss-summary',
      name:'LTDUnitProfitAndLossSummary',
      component: LTDUnitProfitAndLossSummary
    },
    // {
    //   name:'DepreciationNBVAsAt',
    //   component: DepreciationNBVAsAt
    // }
    {
      path:'/depreciation-nbv-report/list',
      name:'DepreciationNBVAsAt',
      component: DepreciationNBVAsAt
    },
    {
      path:'/pm-compliance-facility/list',
      name:'PMComplianceFacilityReport',
      component: PMComplianceFacilityReport
    },
    {
      path:'/pm-compliance-pool/list',
      name:'PMCompliancePoolReport',
      component: PMCompliancePoolReport
    },
    {
      path:'/contract-customer-report/list',
      name:'ContractCustomerReportList',
      component: ContractCustomerReportList
    },
    {
      path:'/contract-equipment-as-at-report/list',
      name:'ContractEquipmentAsAt',
      component: ContractEquipmentAsAt
    },
    {
      path:'/contract-equipment-utilization-report/list',
      name:'ContractEquipmentUtilization',
      component: ContractEquipmentUtilization
    },
    {
      path:'/customer-total-fleet-report/list',
      name:'CustomerTotalFleetReport',
      component: CustomerTotalFleetReport
    },
    {
      path:'/maintenance-inclusions-and-exclusions-report/list',
      name:'MaintenanceInclusionsAndExclusionsReport',
      component: MaintenanceInclusionsAndExclusionsReport
    },
    {
      path:'/repair-history-report/list',
      name:'RepairHistoryReport',
      component: RepairHistoryReport
    },
    {
      path:'/contract-revenue-report/list',
      name:'ContractRevenueReport',
      component: ContractRevenueReport
    },
    {
      path: '/mileage-upload/list',
      name: 'MileageUploadList',
      component: MileageUploadList
    },
    {
      path:'/mileage-upload-detail/list/:batch',
      name: 'MileageUploadDetailList',
      component: MileageUploadDetailList
    },
    {
      path:'/invoice-detail-report/list',
      name:'InvoiceDetailReport',
      component: InvoiceDetailReport
    },
    {
      path:'/annual-actual-contract-metric-report/list',
      name:'AnnualActualMetricVSContractMetric',
      component: AnnualActualMetricVSContractMetric
    },
    {
      path:'/actual-contract-metric-report/list',
      name:'ActualMetricContractMetricReport',
      component: ActualMetricContractMetricReport
    },
    {
      path:'/non-billable-unit-report/list',
      name:'NonBillableUnitReport',
      component: NonBillableUnitReport
    },
    {
      path:'/equipment-accounting-records-report/list',
      name:'EquipmentAccountingRecordsReport',
      component: EquipmentAccountingRecordsReport
    },
    {
      path:'/labor-management-report/list',
      name:'LaborManagementReport',
      component: LaborManagementReport
    },
    {
      path:'/feature-mapping/create',
      name:'FeatureMapping',
      component: FeatureMapping
    },
    {
      path:'/equipment-feature-report/list',
      name:'EquipmentFeatureReport',
      component: EquipmentFeatureReport
    },
    {
      path:'/representative/create',
      name:'RepresentativeCreate',
      component: RepresentativeCreate
    },
    {
      path: '/representative/edit/:id',
      name: 'RepresentativeEdit',
      component: RepresentativeCreate
    },
    {
      path:'/representative/list',
      name:'RepresentativeList',
      component: RepresentativeList
    },
    {
      path:'/out-of-service/create',
      name:'OutOfServiceCreate',
      component: OutOfServiceCreate
    },
    {
      path:'/out-of-service/edit/:id',
      name:'OutOfServiceEdit',
      component: OutOfServiceCreate
    },
    {
      path:'/out-of-service/list',
      name:'OutOfServiceList',
      component: OutOfServiceList
    },
    {
      path:'/depreciation-preview/list',
      name:'DepreciationPreview',
      component: DepreciationPreview
    },
    {
      path:'/customer-discount/create',
      name:'CustomerDiscountCreate',
      component: CustomerDiscountCreate
    },
    {
      path:'/customer-discount/edit/:id',
      name:'CustomerDiscountEdit',
      component: CustomerDiscountCreate
    },
    {
      path:'/customer-discount/list',
      name:'CustomerDiscountList',
      component: CustomerDiscountList
    },
    {
      path:'/discount-customer/view/:id',
      name:'DiscountCustomerList',
      component: DiscountCustomerList
    },
    {
      path:'/sub-system/list',
      name:'SubSystemList',
      component: SubSystemList
    },
    {
      path:'/scope-rate/view/:id',
      name:'ScopeRateView',
      component: ScopeRateView
    },
    // {
    //   path:'/receipt-adjustment/:id',
    //   name:'BankReceiptAdjustment',
    //   component: BankReceiptAdjustment
    // },
    {
      path:'/receipt-adjustment/create',
      name:'BankReceiptAdjustment',
      component: BankReceiptAdjustment
    },
    {
      path:'/job-posting/create',
      name:'JobPostingCreate',
      component: JobPostingCreate
    },
    {
      path:'/job-posting/edit/:id',
      name:'JobPostingEdit',
      component: JobPostingCreate
    },
    {
      path:'/job-posting/list',
      name:'JobPostingList',
      component: JobPostingList
    },
    {
      path:'/jobs/list',
      name:'JobsList',
      component: JobsList
    },
    {
      path:'/physical-count/create',
      name:'PhysicalCountCreate',
      component: PhysicalCountCreate
    },
    {
      path:'/physical-count/list',
      name:'PhysicalCountList',
      component: PhysicalCountList
    },
    {
      path:'/inventory-ticket/list/:id',
      name:'InventoryTicketList',
      component: InventoryTicketList
    },
    {
      path:'/sublet-in-process/list',
      name:'SubletInProcessReport',
      component: SubletInProcessReport
    },
    {
      path:'/fuel-inventory-clearing-Summary/list',
      name:'FuelInventoryClearingSummaryReport',
      component: FuelInventoryClearingSummaryReport
    },
    {
      path:'/cpi-rate-verification-report/list',
      name:'CpiRateVerificationReport',
      component: CpiRateVerificationReport
    },
    {
      path:'/accrued-liability-report/list',
      name:'AccruedLiabilityReport',
      component: AccruedLiabilityReport
    },

    {
      path:'/fuel-price/log',
      name:'FuelPriceLog',
      component: FuelPriceLog
    },
    {
      path:'/system-param/list',
      name:'SystemParamsList',
      component: SystemParamsList
    },

    {
      path:'/system-param/edit/:id',
      name:'SystemParamEdit',
      component: SystemParamCreate
    },
    {
      path:'/debt-note-unit-report/list',
      name:'DebtNoteUnitDetailReport',
      component: DebtNoteUnitDetailReport
    },


    {
      path:'/debt-note-balance/list',
      name:'DebtNoteBalanceReport',
      component: DebtNoteBalanceReport
    },
    {
      path:'/debtnote-roll-forward/list',
      name:'DebtNoteRollForwardReport',
      component: DebtNoteRollForwardReport
    },
    {
      path:'/debt-note-posting-detail/list',
      name:'DebtNotePostingDetailReport',
      component: DebtNotePostingDetailReport
    },
    {
      path:'/notes/list',
      name:'NotesList',
      component: NotesList
    },
    {
      path: '/notes/add',
      name: 'NotesCreate',
      component: NotesCreate
    },
    {
      path: '/notes/edit/:id',
      name: 'NotesEdit',
      component: NotesCreate
    },
    {
      path:'/warranty-claim/report',
      name:'WarrantyClaimReport',
      component: WarrantyClaimReport
    },
    {
      path:'/customer-invoice-line/report',
      name:'CustomerInvoiceLineDetailReport',
      component: CustomerInvoiceLineDetailReport
    },
    {
      path:'/cost-per-metric-unit/report',
      name:'CostPerMetricByUnitReport',
      component: CostPerMetricByUnitReport
    },
    {
      path: '/workorder/invoice/list',
      name: 'WorkOrderInvoiceList',
      component: WorkOrderInvoiceList
    },
    {
      path: '/audit-log/report',
      name: 'ActionAuditReport',
      component: ActionAuditReport
    },
    {
      path: '/leave-holiday/calendar',
      name: 'LeaveHolidayCalendar',
      component: LeaveHolidayCalendar
    },
    {
      path:'/debt-note-schedule/list',
      name:'DebtNoteScheduleReport',
      component: DebtNoteScheduleReport
    },
    {
      path:'/asset-deposit-type/list',
      name:'AssetTypeDepositList',
      component: AssetTypeDepositList
    },
    {
      path:'/asset-deposit-type/create',
      name:'AssetTypeDeposit',
      component: AssetTypeDeposit
    },
    {
      path:'/asset-deposit-type/edit/:id',
      name:'AssetTypeDepositEdit',
      component: AssetTypeDeposit
    },
    {
      path:'/subject/create',
      name:'CommentTypeConfig',
      component: CommentTypeConfig
    },
    {
      path:'/subject/edit/:id',
      name:'CommentTypeConfigEdit',
      component: CommentTypeConfig
    },
    {
      path:'/subject/list',
      name:'CommentTypeConfigList',
      component: CommentTypeConfigList
    },
    {
      path:'/voucher-payment/maintenance/list',
      name:'VoucherPaymentMaintenanceList',
      component: VoucherPaymentMaintenanceList
    },
    {
      path:'/voucher-payment/maintenance/detail/:id',
      name: 'VoucherPaymentMaintenanceDetail',
      component: VoucherPaymentMaintenanceDetail
    },

    {
      path:'/fuel-pump-map/create',
      name:'FuelPumpMapper',
      component: FuelPumpMapper
    },
    {
      path:'/fuel-pump-map/edit/:id',
      name:'FuelPumpMapperEdit',
      component: FuelPumpMapper
    },
    {
      path:'/fuel-pump-map/list',
      name:'FuelTankPumpMapperList',
      component: FuelTankPumpMapperList
    },
    {
      path:'/suggested-order/list',
      name:'SuggestedOrder',
      component: SuggestedOrder
    },
    {
      path:'/depreciation-setup/create',
      name:'DepreciationSetup',
      component: DepreciationSetup
    },
    {
      path:'/depreciation-setup/edit/:id',
      name:'DepreciationSetupEdit',
      component: DepreciationSetup
    },
    {
      path:'/depreciation-setup/list',
      name:'DepreciationSetupList',
      component: DepreciationSetupList
    },
    {
      path:'/gl-balances',
      name:'GLBalances',
      component: GLBalances
    },
    {
      path:'/insurance-certificate/create',
      name:'InsuranceCertificateCreate',
      component: InsuranceCertificateCreate
    },
    {
      path:'/insurance-certificate/list',
      name:'InsuranceCertificateList',
      component: InsuranceCertificateList
    },
    {
      path: '/insurance-certificate/edit/:id',
      name: 'InsuranceCertificateEdit',
      component: InsuranceCertificateCreate
    },
    {
      path:'/gl-transaction/list',
      name:'GLTransactionList',
      component: GLTransactionList
    },
    {
      path:'/gl-transaction/edit/:id',
      name:'GLTransactionEdit',
      component: GLTrasactionUpdate
    },
    // {
    //   name:'WarrantyLimitation',P
    //   component: WarrantyLimitation
    // },


    // {
    //   path: '/report/bounce-emails',
    //   name: 'BounceEmail',
    //   component: BounceEmail
    // },
    {
      path: '/billing-reversing-journal-entry',
      name: 'BillingReversingJournalEntry',
      component: BillingReversingJournalEntry
    },
    {
      path: '/billing-reversing-journal-entry-details/:id',
      name: 'BillingReversingJEDetails',
      component: BillingReversingJEDetails
    },
    {
      path: '/customer-order-pricing/list',
      name: 'CustomerOrderPricingList',
      component: CustomerOrderPricingList
    },
    {
      path: '/customer-order-pricing/create',
      name: 'CustomerOrderPricingCreate',
      component: CustomerOrderPricingCreate
    },
    {
      path: '/customer-order-pricing/edit/:id',
      name: 'CustomerOrderPricingEdit',
      component: CustomerOrderPricingCreate
    },
    {
      path: '/vehicle-order-form/create',
      name: 'CustomerOrderForm',
      component: CustomerOrderForm
    },
    {
      path: '/vehicle-order-form/view/:id',
      name: 'CustomerOrderFormEdit',
      component: CustomerOrderForm
    },
    {
      path: '/vehicle-order-form/preview/:id',
      name: 'CustomerOrderFormPreview',
      component: CustomerOrderFormPreview
    },
    {
      path: '/vehicle-order/list',
      name: 'CustomerOrderList',
      component: CustomerOrderList
    },
    {
      path: '/warranty-claim-review/:id',
      name: 'EvWarrantyClaimReview',
      component: EvWarrantyClaimReview
    },
    {
      path: '/pdc-stock/create',
      name: 'EvComponentInventoryCreate',
      component: EvComponentInventoryCreate
    },
    {
      path: '/pdc-stock/edit/:id',
      name: 'EvComponentInventoryEdit',
      component: EvComponentInventoryCreate
    },
    {
      path: '/pdc-stock/view/:id',
      name: 'EvComponentInventoryView',
      component: EvComponentInventoryView
    },
    {
      path: '/customer/add',
      name: 'ConsumerCreate',
      component: ConsumerCreate
    },
    {
      path: '/customer/list',
      name: 'ConsumerList',
      component: ConsumerList
    },

    {
      path: '/customer/edit/:id',
      name: 'ConsumerEdit',
      component: ConsumerCreate
    },
    {
      path:'/rates/list',
      name:'RatesList',
      component: RatesList
    },
    {
      path:'/rates/add',
      name:'RatesCreate',
      component: RatesCreate
    },
    {
      path:'/rates/edit/:id',
      name:'RatesEdit',
      component: RatesCreate
    },
    {
      path: '/srt/list',
      name: 'SrtList',
      component: SrtList
    },
    {
      path: '/srt/create',
      name: 'SrtCreate',
      component: SrtCreate
    },
    {
      path: '/srt/edit/:id',
      name: 'SrtEdit',
      component: SrtCreate
    },
    {
      path: '/publication/list',
      name: 'PublicationList',
      component: PublicationList
    },
    {
      path: '/publication/create',
      name: 'PublicationCreate',
      component: PublicationCreate
    },
    {
      path: '/publication/edit/:id',
      name: 'PublicationEdit',
      component: PublicationCreate
    },
    {
      path:'/campaign/list',
      name:'CampaignList',
      component: CampaignList
    },
    {
      path:'/campaign/add',
      name:'CampaignCreate',
      component: CampaignCreate
    },
    {
      path:'/campaign/edit/:id',
      name:'CampaignEdit',
      component: CampaignCreate
    },
    {
      path:'/campaign-recall-status/list',
      name:'CampaignRecallVinList',
      component: CampaignRecallVinList
    },
    {
      path:'/campaign-recall-status/:id',
      name:'CampaignRecallVinCreate',
      component: CampaignRecallVinCreate
    },
    {
      path:'/vehicle-information',
      name:'VehicleInformation',
      component: VehicleInformation
    },
    {
      path:'/report-concern',
      name:'UserFeedbackCreate',
      component: UserFeedbackCreate
    },
    {
      path: '/feedback-log',
      name: 'UserFeedbackList',
      component: UserFeedbackList
    },
    {
      path: '/feedback-log/edit/:id',
      name: 'UserFeedbackUpdate',
      component: UserFeedbackUpdate
    },
    {
      path: '/media-gallery/create',
      name: 'GalleryCreate',
      component: GalleryCreate
    },
    {
      path: '/media-gallery/edit/:id',
      name: 'GalleryEdit',
      component: GalleryCreate
    },
    {
      path: '/media-gallery/list',
      name: 'GalleryList',
      component: GalleryList
    },
    {
      path: '/technical-support-request',
      name: 'TechnicalSupportRequest',
      component: TechnicalSupportRequest
    },
    {
      path: '/technical-support-request/edit/:id',
      name: 'TechnicalSupportRequestUpdate',
      component: TechnicalSupportRequest
    },
    {
      path: '/technical-support-queue',
      name: 'TechnicalSupportQueue',
      component: TechnicalSupportQueue
    },
    {
      path: '/vehicle-option/create',
      name: 'VehicleOptionCreate',
      component: VehicleOptionCreate
    },
    {
      path: '/vehicle-option/edit/:id',
      name: 'VehicleOptionEdit',
      component: VehicleOptionCreate
    },
    {
      path: '/vehicle-option/list',
      name: 'VehicleOptionList',
      component: VehicleOptionList
    },
    {
      path: '/retail-delivery-report/create',
      name: 'RetailDeliveryReportCreate',
      component: RetailDeliveryReportCreate
    },
    {
      path: '/retail-delivery-report/list',
      name: 'RetailDeliveryReportList',
      component: RetailDeliveryReportList
    },
    {
      path: '/retail-delivery-report/edit/:id',
      name: 'RetailDeliveryReportEdit',
      component: RetailDeliveryReportCreate
    },
    {
      path: '/create-credit-memo/:id',
      name: 'CreateCreditMemo',
      component: CreateCreditMemo
    },
    {
      path: '/credit-memo-log',
      name: 'CreditMemoLog',
      component: CreditMemoLog
    },
    {
      path: '/position-code/list',
      name: 'PositionCodeList',
      component: PositionCodeList
    },
    {
      path: '/position-code/create',
      name: 'PositionCodeCreate',
      component: PositionCodeCreate
    },
    {
      path: '/position-code/edit/:id',
      name: 'PositionCodeEdit',
      component: PositionCodeCreate
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js